const co2 = 'CO<sub style="font-size:x-small">2</sub>';
const deFootnotesNedc = `Die angegebenen Werte wurden nach dem vorgeschriebenen Messverfahren ermittelt. Es handelt sich um die „NEFZ-${co2}-Werte“ i.S.v. Art. 2 Nr. 1 Durchführungsverordnung (EU) 2017/1153. Die Kraftstoffverbrauchswerte wurden auf Basis dieser Werte errechnet. Die Angaben beziehen sich nicht auf ein einzelnes Fahrzeug und sind nicht Bestandteil des Angebots, sondern dienen allein Vergleichszwecken zwischen verschiedenen Fahrzeugtypen. Die Werte variieren in Abhängigkeit der gewählten Sonderausstattungen. Weitere Informationen zum offiziellen Kraftstoffverbrauch und zu den offiziellen spezifischen ${co2}-Emissionen neuer Personenkraftwagen können dem „Leitfaden über den Kraftstoffverbrauch die ${co2}-Emissionen und den Stromverbrauch neuer Personenkraftwagen“ entnommen werden, der an allen Verkaufsstellen und bei der DAT Deutsche Automobil Treuhand GmbH (www.dat.de) unentgeltlich erhältlich ist.`;
const deFootnotesWltp = `Die angegebenen Werte wurden nach dem vorgeschriebenen Messverfahren ermittelt. Es handelt sich um „WLTP-${co2}-Werte“ i.S.v. Art. 2 Nr. 3 Durchführungsverordnung (EU) 2017/1153. Die Kraftstoffverbrauchswerte wurden auf Basis dieser Werte errechnet. Der Stromverbrauch wurde auf der Grundlage VO 683/2008/ EG ermittelt. Die Angaben beziehen sich nicht auf ein einzelnes Fahrzeug und sind nicht Bestandteil des Angebots, sondern dienen allein Vergleichszwecken zwischen verschiedenen Fahrzeugtypen. Die Werte variieren in Abhängigkeit der gewählten Sonderausstattungen.`;

const arabicMessages = {
  'consumption.co2': 'انبعاثات ثاني أكسيد الكربون',
  'consumption.energy': 'استهلاك الطاقة',
  'consumption.fuel': 'استهلاك الوقود',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc':
    'تم الحصول على الأرقام الموضحة وفقًا لعملية القياس المحددة. إنها "قيم NEDC CO2" وفقًا للمادة 2 رقم 1 من اللائحة التنفيذية (الاتحاد الأوروبي) 2017/1153. تم حساب أرقام استهلاك الوقود على أساس هذه القيم. تم تحديد الاستهلاك الكهربائي على أساس التوجيه 692/2008 / EC.',
  'footnotes.emissions.appendix':
    'لمزيد من المعلومات حول الاستهلاك الرسمي للوقود وانبعاثات ثاني أكسيد الكربون لسيارات الركاب الجديدة ، يرجى الاتصال بوكيل مرسيدس-بنز المعتمد.',
  'search.input.label': 'مصطلح البحث الخاص بك / OnlineCode',
  'search.result.buy-online': 'اشتر عبر الانترنت',
  'search.results':
    'لم يتم العثور على نتائج لهذا البحث | تم العثور على نتيجة واحده لهذا البحث |  تم العثور على نتيجتان لهذا البحث| تم العثور على هذه النتائج : {count}',
  'search.results.backup': 'لم يتم العثور على نتائج دقيقة. تصفح الصفحات ذات الصلة:',
  'search.results.none.summary': 'لا توجد نتائج بحث متاحة لمصطلح البحث هذا. يرجى المحاولة مرة أخرى بمصطلح مختلف',
  'search.results.count': 'تم العثور على نتيجة واحده لهذا البحث : {count}',
  'search.show-more': 'أظهر المزيد',
  'search.unavailable': 'البحث غير متوفر حاليا',
  'search.result.new': 'جديد',
  'search.result.consumption': 'الاستهلاك',
  'input.placeholder': 'مصطلح البحث الخاص بك / OnlineCode',
  'watch.video': 'شاهد الفيديو',
  'input.recently': 'آخر بحث',
  'input.help.title': 'ما الذي تبحث عنه؟',
  'input.help.text': 'ابحث باستخدام أنواع السيارات وطرازاتها وأكواد التهيئة أو عن ملحقات ومنتجات ومعلومات أخرى',

  'search.result.list': 'قائمة',
  'search.result.grid': 'شبكة',

  // Empty support
  'support.check': 'يرجى التحقق من وجود أخطاء إملائية أو المحاولة مرة أخرى باستخدام مصطلح مختلف.',
  'support.no.results': 'لا توجد نتائج بحث متاحة لمصطلح البحث هذا',
  'support.no.results.term': 'لم يتم العثور على نتائج',
  'support.chat': 'ألا تستطيع إيجاد ما تبحث عنه؟ يرجى استخدام دعم الدردشة عبر ',
  'support.chat.with.us': 'الإنترنت',
};

const englishMessages = {
  'consumption.co2': `${co2} emissions combined`,
  'consumption.energy': 'Power consumption in combined test cycle',
  'consumption.fuel': 'Fuel consumption combined',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Your search term / OnlineCode',
  'search.result.buy-online': 'Buy Online',
  'search.results': 'No results found | {count} Search Result | {count} Search Results',
  'search.results.backup': 'No exact matches found. View related pages:',
  'search.results.count': '{count} Search Results',
  'search.results.none.summary':
    'There are no search results available for this search term. Please try again with a different term.',
  'search.show-more': 'Show more',
  'search.unavailable': 'Search is not currently available.',
  'search.didyoumean': 'Did you mean ',
  'search.result.new': 'New',
  'input.placeholder': 'Your search term / OnlineCode',
  'suggestions.all_search_results': 'All search results',
  'suggestions.all_search_results_for': 'Show all search results for',
  'suggestions.in': 'in',

  all: 'All',
  UCOS: 'Used vehicle Online Store',
  PASSENGER_CARS: 'Passenger cars',
  VANS: 'Vans',
  NCOS: 'New vehicle Online Store',
  VIDEO: 'Videos',
  DEALER_LOCATOR: 'Dealer search',
  CONFIGURATOR: 'Mercedes-Benz Car Configurator',
  TEST_DRIVE: 'Test drive',
  VEHICLE_SEARCH: 'Used Cars',
  COLLECT: 'Collection & ACCESSORIES',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Car Accessories',

  'search.result.consumption': 'Consumption',
  'watch.video': 'Watch the video',
  'input.recently': 'Recently Searched',
  'input.help.title': 'What should you look for?',
  'input.help.text':
    'Search using vehicle types, models, configuration codes or for ACCESSORIES, other products and information',

  'search.result.list': 'List',
  'search.result.grid': 'Grid',

  // Empty result
  'support.check': 'Please check for typos or try again with a different term.',
  'support.no.results': 'There are no search results available for this search term.',
  'support.no.results.term': 'No results found',
  'support.chat': "Can't find what you're looking for? Please use our ",
  'support.chat.with.us': 'Online Chat Support',
};

const germanMessages = {
  'consumption.co2': `${co2}-Emissionen kombiniert`,
  'consumption.energy': 'Stromverbrauch',
  'consumption.fuel': 'Kraftstoffverbrauch kombiniert',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Ihr Suchbegriff / Configurator OnlineCode / Model Series / Baumuster',
  'search.result.buy-online': 'Online kaufen',
  'search.results': 'Kein Suchergebnis gefunden | {count} Suchergebnis | {count} Suchergebnisse',
  'search.results.backup': 'Keine genauen Übereinstimmungen gefunden. Verwandte Seiten ansehen:',
  'search.results.count': '{count} Suchergebnisse:',
  'search.results.offer': 'Beliebte Angebote für "{query}":',
  'search.results.none.summary':
    'Es gibt keine Suchergebnisse für diesen Begriff. Bitte versuchen Sie es erneut mit einem anderen Suchbegriff.',
  'search.show-more': 'Mehr anzeigen',
  'search.unavailable': 'Suche ist derzeit nicht verfügbar.',
  'search.result.new': 'Neu',
  // change this
  'input.placeholder': 'Ihr Suchbegriff / Configurator OnlineCode',
  // new part
  'suggestions.all_search_results': 'Alle Suchergebnisse',
  'suggestions.all_search_results_for': 'Alle Ergebnisse anzeigen für',
  'suggestions.in': 'in',
  all: 'Alle',
  UCOS: 'Gebrauchtwagen Online Store',
  PASSENGER_CARS: 'PKW',
  VANS: 'Vans',
  NCOS: 'Neuwagen Online Store',
  VIDEO: 'Videos',
  DEALER_LOCATOR: 'Händlersuche',
  CONFIGURATOR: 'Mercedes-Benz Car Configurator',
  TEST_DRIVE: 'Probefahrt',
  VEHICLE_SEARCH: 'Gebrauchtfahrzeugsuche',
  COLLECT: 'Collection & Zubehör',
  CONNECT: 'Mercedes me Store',
  didyoumean: 'Meinten Sie',
  ACCESSORIES: 'Auto Zubehör',

  'search.result.consumption': 'Verbrauch',
  'watch.video': 'Das Video anschauen',
  'input.recently': 'Kürzlich gesucht',
  'input.help.title': 'Wonach sollten Sie suchen?',
  'input.help.text':
    'Suche unter Verwendung von Fahrzeugart, Modell, Konfigurationscodes oder nach Zubehör, anderen Produkten und Informationen',

  'search.result.list': 'Liste',
  'search.result.grid': 'Raster',

  // Empty page
  'support.check': 'Bitte prüfen Sie auf Tippfehler oder versuchen Sie es noch einmal mit einem anderen Begriff.',
  'support.no.results': 'Es sind keine Suchergebnisse für diesen Suchbegriff vorhanden.',
  'support.no.results.term': 'Keine Ergebnisse gefunden',
  'support.chat': 'Sie finden nicht, wonach Sie suchen? Bitte nutzen Sie unseren ',
  'support.chat.with.us': 'Online-Chat-Support',
};

const croatianMessages = {
  'consumption.co2': `${co2} emisije kombinovano`,
  'consumption.energy': 'Potrošnja energije u kombinovanom ciklusu ispitivanja',
  'consumption.fuel': 'Kombinovana potrošnja goriva',
  'footnotes.local': '',
  'footnotes.wltp':
    'Navedene vrednosti su određene prema propisanoj metodi merenja. Ovo su „WLTP vrednosti CO₂“ u smislu člana 2 br. 3 Implementacione uredbe (EU) 2017/1153. Vrednosti potrošnje goriva su izračunate na osnovu ovih vrednosti. Potrošnja električne energije je određena na osnovu VO 683/2008/EG. Podaci se ne odnose na jedno vozilo i nisu deo ponude, već služe isključivo u svrhu poređenja između različitih tipova vozila. Vrednosti se razlikuju u zavisnosti od izabrane opcione opreme.',
  'footnotes.nedc':
    'Prikazane vrednosti su dobijene u skladu sa propisanim procesom merenja. One su "NEDC CO2 vrednosti" u skladu sa čl. 2 br. 1 Implementacione uredbe (EU) 2017/1153. Brojke potrošnje goriva su izračunate na osnovu ovih vrednosti. Potrošnja električne energije je određena na osnovu Direktive 692/2008/EC.',
  'footnotes.emissions.appendix':
    'Za više informacija o zvaničnoj potrošnji goriva i emisiji CO2 novih putničkih automobila, obratite se svom ovlašćenom Mercedes-Benz dileru.',
  'search.input.label': 'Vaš termin za pretragu / Konfigurator OnlineCode',
  'search.result.buy-online': 'Kupiti preko interneta',
  'search.results': 'Nema rezultata | {count} rezultat pretrage | {count} rezultata pretrage',
  'search.results.backup': 'Nema tačnih podudaranja. Pogledajte povezane stranice:',
  'search.results.count': '{count} rezultata pretrage',
  'search.results.none.summary':
    'Nema dostupnih rezultata pretrage za ovaj termin za pretragu. Pokušajte ponovo sa drugim terminom.',
  'search.show-more': 'Prikaži više',
  'search.unavailable': 'Pretraga trenutno nije dostupna.',
  'search.result.new': 'Novi',
  'search.result.consumption': 'Spotřeba',
  'watch.video': 'Podívejte se na video',
  'input.recently': 'Nedávno vyhledané',
  'input.help.title': 'Co byste měli hledat?',
  'input.help.text':
    'Vyhledávejte podle typů vozidel, modelů, konfiguračních kódů nebo příslušenství, další produkty a informace',

  'search.result.grid': 'Mreža',
  'search.result.list': 'Popis',

  // Empty page
  'support.check': 'Provjerite pravopisne pogreške ili pokušajte ponovno s drugim izrazom.',
  'support.no.results': 'Nema dostupnih rezultata pretraživanja za ovaj pojam pretraživanja.',
  'support.no.results.term': 'Nema rezultata',
  'support.chat': 'Ne možete pronaći ono što tražite? Molimo koristite našu online-chat-podršku',
  'support.chat.with.us': 'Online Chat Support',
};

export const translations = {
  ar_XA: arabicMessages,
  ar_XD: arabicMessages,
  ar_XH: arabicMessages,
  en_XA: {
    ...englishMessages,
    'footnotes.nedc':
      'The figures shown were obtained in accordance with the prescribed measuring process. They are "NEDC CO2 values" pursuant to Art. 2 No. 1 of Implementing Regulation (EU) 2017/1153. The fuel consumption figures have been calculated on the basis of these values. Electrical consumption has been determined on the basis of Directive 692/2008/EC.',
  },
  en_XD: {
    ...englishMessages,
    'footnotes.nedc':
      'The figures shown were obtained in accordance with the prescribed measuring process. They are "NEDC CO2 values" pursuant to Art. 2 No. 1 of Implementing Regulation (EU) 2017/1153. The fuel consumption figures have been calculated on the basis of these values. Electrical consumption has been determined on the basis of Directive 692/2008/EC.',
  },
  en_XH: {
    ...englishMessages,
    'footnotes.nedc':
      'The figures shown were obtained in accordance with the prescribed measuring process. They are "NEDC CO2 values" pursuant to Art. 2 No. 1 of Implementing Regulation (EU) 2017/1153. The fuel consumption figures have been calculated on the basis of these values. Electrical consumption has been determined on the basis of Directive 692/2008/EC.',
  },
  de_AQ: {
    ...germanMessages,
    'footnotes.nedc': deFootnotesNedc,
  },
  de_AT: {
    'consumption.co2': `${co2} Emissionen gesamt (kombiniert)`,
    'consumption.energy': 'Stromverbrauch gesamt (kombiniert)',
    'consumption.fuel': 'Kraftstoffverbrauch gesamt (kombiniert)',
    'footnotes.local': '',
    'footnotes.wltp':
      'Die angegebenen Werte wurden nach dem vorgeschriebenen Messverfahren ermittelt. Es handelt sich um „WLTP-CO2-Werte“ i. S. v. Art. 2 Nr. 3 Durchführungsverordnung (EU) 2017/1153. Die Kraftstoffverbrauchswerte wurden auf Basis dieser Werte errechnet. Der Stromverbrauch wurde auf der Grundlage VO 683/2008/EG ermittelt. Die Angaben beziehen sich nicht auf ein einzelnes Fahrzeug und sind nicht Bestandteil des Angebots, sondern dienen allein Vergleichszwecken zwischen verschiedenen Fahrzeugtypen. Die Werte variieren in Abhängigkeit der gewählten Sonderausstattungen und können sich von den finalen Werten des bestellten bzw. ausgelieferten Fahrzeugs unterscheiden. Tippfehler vorbehalten.',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix':
      'Weitere Informationen zum offiziellen Kraftstoffverbrauch und zu den CO2-Emissionen neuer Fahrzeuge erhalten Sie bei Ihrem Mercedes-Benz Partner.',
    'search.input.label': 'Ihr Suchbegriff / Konfigurator OnlineCode',
    'search.result.buy-online': 'Online kaufen',
    'search.results': 'Kein Suchergebnis gefunden | {count} Suchergebnis | {count} Suchergebnisse',
    'search.results.backup': 'Keine genauen Übereinstimmungen gefunden. Ähnliche Seiten ansehen:',
    'search.results.none.summary':
      'Für diesen Suchbegriff sind keine Suchergebnisse vorhanden. Bitte versuchen Sie es erneut mit einem anderen Suchbegriff.',
    'search.show-more': 'Mehr anzeigen',
    'search.unavailable': 'Die Suche ist derzeit nicht verfügbar.',
    'search.results.count': '{count} Suchergebnisse',
    'search.results.offer': 'PBeliebte Angebote für "{query}":',
    'search.result.new': 'Neu',
    'search.result.consumption': 'Verbrauch',

    'watch.video': 'Das Video anschauen',
    'input.recently': 'Kürzlich gesucht',
    'input.help.title': 'Wonach sollten Sie suchen?',
    'input.help.text':
      'Suche unter Verwendung von Fahrzeugart, Modell, Konfigurationscodes oder nach Zubehör, anderen Produkten und Informationen',

    'search.result.grid': 'Raster',
    'search.result.list': 'Liste',

    //Empty page
    'support.check': 'Bitte prüfen Sie auf Tippfehler oder versuchen Sie es noch einmal mit einem anderen Begriff.',
    'support.no.results': 'Es sind keine Suchergebnisse für diesen Suchbegriff vorhanden.',
    'support.no.results.term': 'Keine Ergebnisse gefunden',
    'support.chat': 'Sie finden nicht, wonach Sie suchen? Bitte nutzen Sie unseren ',
    'support.chat.with.us': 'Online-Chat-Support',
  },
  de_DE: {
    ...germanMessages,
    'footnotes.nedc': deFootnotesNedc,
    'footnotes.wltp': deFootnotesWltp,
  },
  de_LU: {
    ...germanMessages,
    'footnotes.wltp': `Die angegebenen Werte wurden nach dem vorgeschriebenen Messverfahren ermittelt. Es handelt sich um die „WLTP ${co2}-Werte“ i.S.v. Art. 2 Nr. 1 Durchführungsverordnung (EU) 2017/1153. Die Kraftstoffverbrauchswerte wurden auf Basis dieser Werte errechnet. Der Stromverbrauch wurde auf der Grundlage der VO 692/2008/EG ermittelt. Die angegebenen Werte beziehen sich nicht auf ein bestimmtes Fahrzeug. Ihr einziger Zweck besteht darin, einen Vergleich zwischen verschiedenen Fahrzeugen zu ermöglichen. Die Werte können je nach Ausstattung und gewählten Optionen variieren.`,
    'footnotes.nedc': deFootnotesNedc,
  },
  en_AQ: englishMessages,
  en_GB: englishMessages,
  en_US: englishMessages,
  en_ZA: {
    ...englishMessages,
    'footnotes.nedc': `The figures shown were obtained in accordance with the prescribed measuring process. They are "NEDC ${co2} values" pursuant to Art. 2 No. 1 of Implementing Regulation (EU) 2017/1153. The fuel consumption figures have been calculated on the basis of these values. Electrical consumption has been determined on the basis of Directive 692/2008/EC.`,
  },
  fr_BE: {
    'consumption.co2': `${co2} emissions combined`,
    'consumption.energy': 'Power consumption in combined test cycle',
    'consumption.fuel': 'Fuel consumption combined',
    'footnotes.local': '',
    'footnotes.wltp': `Les valeurs indiquées ont été déterminées selon les méthodes de mesure prescrites. Il s'agit des « valeurs ${co2} WLTP » au sens de l'article 2 nr. 3 du règlement d'exécution (EU) 2017/1153. Les valeurs de consommation ont été calculées sur la base de ces valeurs. La consommation électrique a été déterminée sur la base de la directive 692/2008/CE. Les valeurs indiquées ne sont pas liées à un véhicule en particulier. Elles ont pour seul but de permettre la comparaison entre différents véhicules. Les valeurs peuvent varier selon les équipements et options choisies.`,
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Votre mot clé / code en ligne',
    'search.result.buy-online': 'Buy Online',
    'search.results':
      'Aucun résultat de recherche | {count} Résultat de la recherche | {count} Résultats de la recherche',
    'search.results.backup': 'Aucune correspondance exacte trouvée. Voir les pages liées:',
    'search.results.count': '{count} Résultats de la recherche',
    'search.results.none.summary':
      "Il n'y a pas de résultats de recherche disponibles pour ce terme. Veuillez réessayer avec un terme différent.",
    'search.show-more': 'En savoir plus',
    'search.unavailable': "La recherche n'est pas disponible actuellement.",
    'search.result.new': 'Nieuw',

    'input.placeholder': 'Votre mot clé / code en ligne',

    'watch.video': 'Regarder la vidéo',
    'input.recently': 'Récemment recherché',
    'input.help.title': 'What should you look for?',
    'input.help.text':
      'Search using vehicle types, models, configuration codes or for ACCESSORIES, other products and information',

    'search.result.grid': 'Grille',
    'search.result.list': 'Liste',

    // No results found
    'support.check': "Veuillez vérifier les fautes d'orthographe ou réessayer avec une autre phrase",
    'support.no.results': "Aucun résultat de recherche n'est disponible pour ce terme de recherche.",
    'support.no.results.term': 'Aucun résultat',
    'support.chat': 'Vous ne trouvez pas ce que vous cherchez? Veuillez utiliser notre support de chat en ligne',
    'support.chat.with.us': 'Online Chat Support',
    'search.result.consumption': 'Consommation',
  },
  da_DK: {
    //Denmark
    'consumption.co2': `${co2} ved blandet kørsel`,
    'consumption.energy': 'Energiforbrug ved blandet kørsel',
    'consumption.fuel': 'Brændstofforbrug ved blandet kørsel',
    'footnotes.local': '',
    'footnotes.wltp': `De oplyste værdier er beregnet i overensstemmelse med den foreskrevne målemetode. Der er tale om „WLTP-${co2}-værdier“ i henhold til art. 2 nr. 3 i gennemførelsesforordning (EU) 2017/1153. Brændstofforbrugsværdierne er beregnet på grundlag af disse værdier. Strømforbruget er beregnet på grundlag af forordningen 683/2008/EF. Angivelserne er ikke baseret på en enkelt bil og indgår ikke i produktomfanget, men er udelukkende beregnet til sammenligning mellem forskellige biltyper. Værdierne varierer afhængigt af det valgte ekstraudstyr.`,
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': `Kontakt din autoriserede Mercedes-Benz forhandler for yderligere information om officielle forbrugstal og ${co2}-emissioner for nye biler.`,
    'search.input.label': 'Din søgning / OnlineCode Configurator',
    'search.results': 'Intet resultat fundet. | {count} Søgeresultat | {count} Søgeresultat',
    'search.result.buy-online': 'Buy Online',
    'search.results.count': '{count} Søgeresultat',
    'search.results.backup': 'Intet match fundet. Se relateret materiale:',
    'search.results.none.summary':
      'Der er ingen søgeresultater til gengængelige for din søgning. Prøv igen med en anden søgning.',
    'search.show-more': 'Vis mere',
    'search.unavailable': 'Søgning er ikke tilgængelig lige nu.',
    'search.result.new': 'Ny',
    'input.placeholder': 'Din søgning / OnlineCode Configurator',

    'suggestions.all_search_results': 'Alle søgeresultater',
    'suggestions.all_search_results_for': 'Vis alle resultater for',
    'suggestions.in': 'i',
    // <--------------  end this

    all: 'Alle',
    UCOS: 'Brugte biler onlinebutik',
    PASSENGER_CARS: 'Personbil',
    VANS: 'MPV',
    NCOS: 'Nye biler onlinebutik',
    VIDEO: 'Videoer',
    DEALER_LOCATOR: 'Forhandlersøgning',
    CONFIGURATOR: 'Mercedes-Benz Car Configurator',
    TEST_DRIVE: 'Prøvetur',
    VEHICLE_SEARCH: 'Søgning efter brugt bil',
    COLLECT: 'Collection & tilbehør',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'Biltilbehør',

    'search.result.consumption': 'Forbrug',
    'watch.video': 'Se videoen',
    'input.recently': 'Søgt for nylig',
    'input.help.title': 'Hvad skal du kigge efter?',
    'input.help.text':
      'Søg ved hjælp af biltyper, modeller, konfigurationskoder eller efter tilbehør, andre produkter og oplysninger',

    'search.result.list': 'Liste',
    'search.result.grid': 'Gitter',

    // No results found
    'support.check': 'Tjek venligst for tastefejl, eller prøv igen med et andet udtryk.',
    'support.no.results': 'Der er ingen tilgængelige søgeresultater for denne søgeterm.',
    'support.no.results.term': 'Ingen resultater fundet',
    'support.chat': 'Kan du ikke finde det, du leder efter? Brug venligst vores',
    'support.chat.with.us': 'online-chat-support',
  },
  sv_SE: {
    'consumption.co2': `Viktat ${co2}-utsläpp, blanwdad körning`,
    'consumption.energy': 'Viktad strömförbrukning, blandad körning ',
    'consumption.fuel': 'Förbrukning blandad körning',
    'footnotes.local': '',
    'footnotes.wltp': `De angivna värdena har fastställts i enlighet med föreskrivet mätförfarande. Det rör sig om ”WLTP-${co2}-värdet” i den mening som avses i artikel 2, stycke 3 i Kommissionens genomförandeförordning (EU) 2017/1153. Värdena för bränsleförbrukning har beräknats utifrån dessa värden. Strömförbrukningen har fastställts utifrån förordning 683/2008/EG. Angivna värden avser inte ett enskilt fordon och är inte en del av ett erbjudande, utan tjänar enbart som jämförelse mellan de olika fordonstyperna. Samtliga utsläppsvärden gäller bil i grundversion. Högre utrustningsnivå, svensk standardutrustning, större däckdimension och högre vikt kan ge högre bränsleförbrukning och koldioxidutsläpp. Fordonsindividuella uppgifter om förbrukning och utsläpp finns på Konsumentverkets webbtjänst www.bilsvar.se Värdena varierar också beroende på eventuella tillval (extrautrustning).`,
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': `För mer information kring förbrukning och ${co2} utsläpp av nya bilar, vänligen kontakta din Mercedes-Benz agent.`,
    'search.input.label': 'Din sökterm / Onlinekod konfiguratorn',
    'search.results': 'Inga resultat funna. | {count} Sökresultat | {count} Sökresultat',
    'search.results.count': '{count} Sökresultat',
    'search.result.buy-online': 'Köp online',
    'search.results.backup': 'Inga matchande resultat. Se liknande sidor:',
    'search.results.none.summary': 'Det finns inga resultat för denna sökterm. Vänligen prova med en annan sökterm.',
    'search.show-more': 'Visa mer',
    'search.unavailable': 'Sök fungerar ej för tillfället.',
    'search.result.new': 'Ny',
    'search.result.consumption': 'Förbrukning',

    'input.placeholder': 'Din sökterm / Onlinekod konfiguratorn',

    'suggestions.all_search_results': 'Alla sökresultat',
    'suggestions.all_search_results_for': 'Visa alla resultat för',
    'suggestions.in': 'i',
    all: 'Alla',
    UCOS: 'Online Store för begagnade bilar',
    PASSENGER_CARS: 'Personbil',
    VANS: 'Transportbilar',
    NCOS: 'Online Store för nya bilar',
    VIDEO: 'Videor',
    DEALER_LOCATOR: 'Hitta din återförsäljare',
    CONFIGURATOR: 'Mercedes-Benz Car Configurator',
    TEST_DRIVE: 'Provkörning',
    VEHICLE_SEARCH: 'Sök begagnad bil',
    COLLECT: 'Collection och tillbehör',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'Biltilbehør',

    'watch.video': 'Titta på videon',
    'input.recently': 'Nyligen sökt',
    'input.help.title': 'Vad ska du leta efter?',
    'input.help.text':
      'Sök med hjälp av fordonstyper, modeller, konfigurationskoder eller efter tillbehör, andra produkter och information.',

    'search.result.list': 'Lista',
    'search.result.grid': 'Rutnät',

    // No results found
    'support.check': 'Kontrollera om du har stavat fel eller försök igen med en annan term.',
    'support.no.results': 'Det finns inga sökresultat för denna sökterm.',
    'support.no.results.term': 'Inga resultat hittades',
    'support.chat': 'Hittar du inte det du söker? Använd vår ',
    'support.chat.with.us': 'Online-Chat-support',
  },
  fr_LU: {
    'consumption.co2': `${co2} emissions combined`,
    'consumption.energy': 'Power consumption in combined test cycle',
    'consumption.fuel': 'Fuel consumption combined',
    'footnotes.local': '',
    'footnotes.wltp': `Les valeurs indiquées ont été déterminées selon les méthodes de mesure prescrites. Il s'agit des « valeurs ${co2} WLTP » au sens de l'article 2 nr. 3 du règlement d'exécution (EU) 2017/1153. Les valeurs de consommation ont été calculées sur la base de ces valeurs. La consommation électrique a été déterminée sur la base de la directive 692/2008/CE. Les valeurs indiquées ne sont pas liées à un véhicule en particulier. Elles ont pour seul but de permettre la comparaison entre différents véhicules. Les valeurs peuvent varier selon les équipements et options choisies.`,
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Votre mot clé / code en ligne',
    'search.result.buy-online': 'Buy Online',
    'search.results':
      'Aucun résultat de recherche | {count} Résultat de la recherche | {count} Résultats de la recherche',
    'search.results.backup': 'Aucune correspondance exacte trouvée. Voir les pages liées:',
    'search.results.count': '{count} Résultats de la recherche',
    'search.results.none.summary':
      "Il n'y a pas de résultats de recherche disponibles pour ce terme. Veuillez réessayer avec un terme différent.",
    'search.show-more': 'En savoir plus',
    'search.title': 'Que cherchez-vous?',
    'search.unavailable': "La recherche n'est pas disponible actuellement.",
    'search.result.new': 'Nouveau',
    'input.placeholder': 'Votre mot clé / code en ligne',

    'search.result.consumption': 'Consommation',
    'watch.video': 'Regarder la vidéo',
    'input.recently': 'Récemment recherché',
    'input.help.title': 'Que devriez-vous recherchez ?',
    'input.help.text':
      "Rechercher par types de véhicules, modèles, codes de configuration ou rechercher des accessoires, d'autres produits et informations",

    'search.result.grid': 'Grid',
    'search.result.list': 'List',

    // No results found
    'support.check': 'Kuckt w.e.g. op Tippfehler oder probéiert nach eng Kéier mat engem anere Begrëff.',
    'support.no.results': 'Et gi keng Sichresultater fir dëse Sichbegrëff verfügbar.',
    'support.no.results.term': 'Keng Resultater fonnt',
    'support.chat': 'Kënnt Dir net fannen wat Dir sicht? Benotzt w.e.g. eisen ',
    'support.chat.with.us': 'Online-Chat-Support',
  },
  hu_HU: {
    'consumption.co2': `Kombinált ${co2} kibocsátás`,
    'consumption.energy': 'Kombinált áramfogyasztás',
    'consumption.fuel': 'Kombinált üzemanyag-fogyasztás',
    'footnotes.local': '',
    'footnotes.wltp':
      'Az értékek a Bizottság (EU) 2017/1151 rendeletének XXI. mellékletében meghatározott WLTP mérési módszer alapján kerültek meghatározásra. Az üzemanyag-fogyasztási értékek kiszámítása ezen értékek alapján történt. Az adatok nem egy adott gépjárműre vonatkoznak, és nem képezik ajánlat részét, hanem kizárólag a különböző gépjárműtípusok egymással való összehasonlítására szolgálnak. Az értékek a kiválasztott extrafelszereltségek függvényében változnak.',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Keresett kifejezés / OnlineCode',
    'search.result.buy-online': 'Buy Online',
    'search.results': 'Nincs találat | {count} keresési eredmény | {count} Keresési eredmények',
    'search.results.backup': 'Nem található pontos egyezés. Kapcsolódó oldalak megtekintése:',
    'search.results.count': '{count} Keresési eredmények',
    'search.results.none.summary':
      'Nincs elérhető keresési eredmény ehhez a keresési kifejezéshez. Kérjük, próbálja meg újra egy másik kifejezéssel.',
    'search.show-more': 'További találatok',
    'search.unavailable': 'A keresés jelenleg nem érhető el.',
    'search.result.new': 'Új',

    'input.placeholder': 'Keresett kifejezés / OnlineCode',

    'suggestions.all_search_results': 'Összes ker. eredm',
    'suggestions.all_search_results_for': 'Össszes eredmény ehhez',
    'suggestions.in': 'itt:',

    all: 'Összes',
    UCOS: 'Mercedes-Benz használt gépjárművek',
    PASSENGER_CARS: 'Személygépkocsik',
    VANS: 'Kishaszonjárművek',
    NCOS: 'Mercedes-Benz online showroom',
    VIDEO: 'Videók',
    DEALER_LOCATOR: 'Márkaképviselet keresése',
    CONFIGURATOR: 'Mercedes-Benz személygépkocsi konfigurátor',
    TEST_DRIVE: 'Tesztvezetés',
    VEHICLE_SEARCH: 'Gépjármű keresés',
    COLLECT: 'Kollekció és tartozékok',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'Biltilbehør',

    'search.result.consumption': 'Fogyasztás',
    'watch.video': 'Videó megtekintése',
    'input.recently': 'Legutóbbi keresés',
    'input.help.title': 'Mi alapján kereshet?',
    'input.help.text':
      'Keressen gépkocsitípusok, modellek, konfigurációkódok vagy tartozékok, egyéb termékek és információk használatával',

    // No results found
    'support.check': 'Kérjük, ellenőrizze, hogy nincs-e elírás, vagy próbálja újra egy másik kifejezéssel.',
    'support.no.results': 'Nincsenek találatok erre a kifejezésre.',
    'support.no.results.term': 'Nincsenek találatok',
    'support.chat': 'Nem találja, amit keres? Kérjük, használja az',
    'support.chat.with.us': 'online chates támogatást',
  },
  no_NO: {
    'consumption.co2': `${co2} utslipp kombinert`,
    'consumption.energy': 'Strømforbruk i kombinert testsyklus',
    'consumption.fuel': 'Drivstofforbruk kombinert',
    'footnotes.local': '',
    'footnotes.wltp': `De angitte verdiene er beregnet i henhold til foreskrevne måleprosedyrer. Det dreier seg om "WLTP-${co2}-verdier“ iht. § 2 nr. 3 Gjennomføringsforordning (EU) 2017/1153. Drivstofforbruket er beregnet på basis av disse verdiene. Strømforbruket ble beregnet i samsvar med forordning 683/2008/EF. Verdiene gjelder ikke ett enkelt kjøretøy og inngår ikke i tilbudet, men er kun referanseverdier for sammenligning mellom forskjellige modellvarianter. Verdiene varierer avhengig av valgt tilleggsutstyr og kan være forskjellig fra de endelige verdiene til den bestilte eller utleverte bilen. Verdiene påvirkes også av forskjellige faktorer som f.eks. personlig kjørestil, forhold i omgivelsene og egenskaper ved den aktuelle kjøreruten. WLTP-verdiene er ihht fabrikkstandardutstyrt bil.`,
    'footnotes.nedc': '',
    'footnotes.emissions.appendix':
      'Vennligst kontakt din autoriserte Mercedes-Benz forhandler for mer informasjon om forbruks- og utslippsdata.',
    'search.input.label': 'Ditt søkeord/Online-kode konfigurator',
    'search.result.buy-online': 'Kjøp på nettet',
    'search.results': 'Ingen søkeresultat ble funnet | {count} søkeresultat | {count} søkeresultater',
    'search.results.backup': 'Ingen eksakte treff funnet. Se relaterte sider:',
    'search.results.count': '{count} søkeresultater',
    'search.results.none.summary':
      'Det er ingen søkeresultater tilgjengelig for dette søkeordet. Prøv igjen med et annet begrep.',
    'search.show-more': 'Vis mer',
    'search.unavailable': 'Søk er for øyeblikket ikke tilgjengelig.',
    'search.result.new': 'Ny',

    'search.result.consumption': 'Forbruk',

    'input.placeholder': 'Ditt søkeord/Online-kode konfigurator',

    'suggestions.all_search_results': 'Alle søkeresultater',
    'suggestions.all_search_results_for': 'Vis alle resultater for',
    'suggestions.in': 'i',

    all: 'Alle',
    UCOS: 'Bruktbiler Online Store"',
    PASSENGER_CARS: 'Personbil',
    VANS: 'Varebiler',
    NCOS: 'Nye biler Online Store',
    VIDEO: 'Videoer',
    DEALER_LOCATOR: 'Forhandlersøk',
    CONFIGURATOR: 'Mercedes-Benz Car Configurator',
    TEST_DRIVE: 'Prøvekjøring',
    VEHICLE_SEARCH: 'Bruktbilsøk',
    COLLECT: 'Collection og tilbehør',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'Biltilbehør',

    'watch.video': 'Se videoen',
    'input.recently': 'Nylig søkte',
    'input.help.title': 'Hva bør du se etter?',
    'input.help.text':
      'Søk ved å bruke kjøretøytyper, modeller, konfigurasjonskoder eller søk etter tilbehør, andre produkter og informasjon',

    // No results found
    'support.check': 'Sjekk etter skrivefeil eller prøv igjen med et annet søkeord.',
    'support.no.results': 'Det finnes ingen søkeresultater for dette søkeordet.',
    'support.no.results.term': 'Finner ingen resultater.',
    'support.chat': 'Finner du ikke det du leter etter?Bruk vår.',
    'support.chat.with.us': 'Online chat-tjeneste.',
  },
  nl_BE: {
    'consumption.co2': `${co2} emissions combined`,
    'consumption.energy': 'Power consumption in combined test cycle',
    'consumption.fuel': 'Fuel consumption combined',
    'footnotes.local': '',
    'footnotes.wltp': `De vermelde waarden zijn gemeten volgens de voorgeschreven meetmethode. Het betreft ‘WLTP-${co2}-waarden’ conform Art. 2 Nr. 3 van de doorvoerverordening (EU) 2017/1153. De waarden van het brandstofverbruik zijn op basis van deze waarden bepaald. Het stroomverbruik werd berekend op basis van VO 683/2008/EG. De opgaven hebben geen betrekking op een specifiek voertuig, ze zijn slechts bedoeld ter vergelijking van verschillende voertuigen onderling. De waarden variëren al naargelang de gekozen opties.`,
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Uw zoekterm / Configurator OnlineCode',
    'search.result.buy-online': 'Buy Online',
    'search.results': 'Geen zoekresultaten | {count} Zoekresultaat | {count} Zoekresultaten',
    'search.results.count': '{count} Zoekresultaten',
    'search.results.backup': "Geen exacte overeenkomsten gevonden. Bekijk gerelateerde pagina's:",
    'search.results.none.summary':
      'Er zijn geen zoekresultaten beschikbaar voor deze zoekterm. Probeer het opnieuw met een andere term.',
    'search.show-more': 'Bekijk meer.',
    'search.unavailable': 'Zoeken is momenteel niet beschikbaar.',
    'search.result.new': 'Nieuw',
    'input.placeholder': 'Uw zoekterm / Configurator OnlineCode',

    'search.result.consumption': 'Verbruik',
    'watch.video': 'Bekijk de video',
    'input.recently': 'Onlangs naar gezocht',
    'input.help.title': 'Waarnaar moet u zoeken?',
    'input.help.text':
      'Zoek aan de hand van voertuigtypen, modellen of configuratiecodes naar accessoires, andere producten en informatie',

    // No results found
    'support.check': 'Bitte prüfen Sie auf Tippfehler oder versuchen Sie es noch einmal mit einem anderen Begriff.',
    'support.no.results': 'Es sind keine Suchergebnisse für diesen Suchbegriff vorhanden.',
    'support.no.results.term': 'Keine Ergebnisse gefunden',
    'support.chat': 'Sie finden nicht, wonach Sie suchen? Bitte nutzen Sie unseren ',
    'support.chat.with.us': 'online-chat-support',
  },
  nl_NL: {
    'consumption.co2': `${co2} emissions combined`,
    'consumption.energy': 'Power consumption in combined test cycle',
    'consumption.fuel': 'Fuel consumption combined',
    'footnotes.local': '',
    'footnotes.wltp': `De opgegeven waarden zijn vastgesteld volgens de voorgeschreven meetprocedure. De opgegeven waarden zijn de gemeten WLTP-${co2}-waarden conform art. 2 lid 3 uitvoeringsverordening (EU) 2017/1153. De waarden met betrekking tot het brandstofverbruik zijn berekend op basis van deze waarden. Het stroomverbruik is vastgesteld aan de hand van VO 683/2008/EG. De opgaven hebben geen betrekking op een specifiek voertuig. Ze zijn slechts bedoeld ter vergelijking van de verschillende voertuigtypen. De waarden kunnen variëren afhankelijk van de gekozen opties.`,
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Uw zoekterm / Configurator OnlineCode',
    'search.result.buy-online': 'Buy Online',
    'search.results': 'Geen zoekresultaten | {count} Zoekresultaat | {count} Zoekresultaten',
    'search.results.count': '{count} Zoekresultaten',
    'search.results.backup': "Geen exacte overeenkomsten gevonden. Bekijk gerelateerde pagina's:",
    'search.results.none.summary':
      'Er zijn geen zoekresultaten beschikbaar voor deze zoekterm. Probeer het opnieuw met een andere term.',
    'search.show-more': 'Bekijk meer.',
    'search.unavailable': 'Zoeken is momenteel niet beschikbaar.',
    'search.result.new': 'Nieuw',

    'input.placeholder': 'Uw zoekterm / Configurator OnlineCode',

    'search.result.consumption': 'Verbruik',
    'watch.video': 'Bekijk de video',
    'input.recently': 'Onlangs naar gezocht',
    'input.help.title': 'Waarnaar moet u zoeken?',
    'input.help.text':
      'Zoek aan de hand van voertuigtypen, modellen of configuratiecodes naar accessoires, andere producten en informatie',

    // No results found
    'support.check': 'Bitte prüfen Sie auf Tippfehler oder versuchen Sie es noch einmal mit einem anderen Begriff.',
    'support.no.results': 'Es sind keine Suchergebnisse für diesen Suchbegriff vorhanden.',
    'support.no.results.term': 'Keine Ergebnisse gefunden',
    'support.chat': 'Sie finden nicht, wonach Sie suchen? Bitte nutzen Sie unseren ',
    'support.chat.with.us': 'Online-Chat-Support',
  },
  pl_PL: {
    'consumption.co2': `Średnia emisja ${co2}`,
    'consumption.energy': 'Zużycie energii',
    'consumption.fuel': 'Średnie zużycie paliwa',
    'footnotes.local': '',
    'footnotes.wltp': `Podane wartości zostały oznaczone zgodnie z metodą pomiarową określoną przepisami. Są to „wartości ${co2} WLTP”, w rozumieniu Art. 2 nr 3 rozporządzenia wykonawczego (UE) 2017/1153. Parametry zużycia paliwa zostały obliczone na podstawie tych danych. Zużycie prądu obliczono zgodnie z rozporządzeniem 683/2008/WE. Dane nie dotyczą konkretnego pojazdu i nie są częścią oferty, lecz służą jedynie porównaniu różnych typów pojazdu. Wartości różnią się w zależności od wybranego wyposażenia dodatkowego i mogą się różnić od końcowych wartości zamówionego wzgl. dostarczonego pojazdu.`,
    'footnotes.nedc': `Podane wartości ustalono zgodnie z przewidzianą przepisami procedurą pomiarową. Są to „wartości ${co2} WLTP” w rozumieniu Art. 2 pkt 3 rozporządzenia wykonawczego (UE) 2017/1153. Wartości zużycia paliwa obliczono na bazie tych danych. Dane nie dotyczą konkretnego pojazdu i nie są częścią oferty, lecz służą jedynie porównaniu różnych typów pojazdu. Wartości różnią się w zależności od wybranego wyposażenia dodatkowego i mogą się różnić od końcowych wartości zamówionego wzgl. dostarczonego pojazdu. Zużycie prądu zostało określone na podstawie rozporządzenia 692/2008/WE.`,
    'footnotes.emissions.appendix': `Więcej informacji na temat oficjalnego zużycia paliwa oraz poziomu emisji ${co2} nowych samochodów osobowych można uzyskać u autoryzowanych dealerów Mercedes-Benz.`,
    'search.input.label': 'Wyszukiwane słowo / kod online',
    'search.result.buy-online': 'Buy Online',
    'search.results': 'Nie znaleziono wyników | Wynik wyszukiwania: {count} | Wyniki wyszukiwania: {count}',
    'search.results.count': ' Wyniki wyszukiwania: {count}',
    'search.results.backup': 'Nie znaleziono dokładnych dopasowań. Wyświetl powiązane strony:',
    'search.results.none.summary':
      'Brak dostępnych wyników wyszukiwania dla tego słowa. Spróbuj ponownie, używając innego słowa.',
    'search.show-more': 'Pokaż więcej',
    'search.unavailable': 'Wyszukiwanie nie jest obecnie dostępne.',
    'search.result.new': 'Nowy',

    'input.placeholder': 'Wyszukiwane słowo / kod online',

    'suggestions.all_search_results': 'Wszystkie rezultaty wyszukiwania',
    'suggestions.all_search_results_for': 'Pokaż wszystkie rezultaty wyszukiwania dla',
    'suggestions.in': 'w',

    all: 'Wszystkie',
    UCOS: 'Salon Online z samochodami używanymi',
    PASSENGER_CARS: 'Samochód osobowy',
    VANS: 'Vany',
    NCOS: 'Salon Online z samochodami nowymi',
    VIDEO: 'Filmy',
    DEALER_LOCATOR: 'Wyszukiwanie dealerów',
    CONFIGURATOR: 'Konfigurator samochodów Mercedes-Benz',
    TEST_DRIVE: 'Jazda testowa',
    VEHICLE_SEARCH: 'Wyszukiwarka samochodów używanych',
    COLLECT: 'Kolekcja i akcesoria',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'Akcesoria samochodowe',

    'search.result.consumption': 'Konsumpcja',
    'watch.video': 'Obejrzyj wideo',
    'input.recently': 'Ostatnio wyszukiwane',
    'input.help.title': 'Czego powinieneś szukać?',
    'input.help.text':
      'Szukaj według typów pojazdów, modeli, kodów konfiguracyjnych lub akcesoriów, innych produktów i informacji',

    // No results found
    'support.check': 'Sprawdź, czy we frazie nie ma literówek lub wpisz inną frazę.',
    'support.no.results': 'Nie znaleziono wyników pasujących dla podanej frazy.',
    'support.no.results.term': 'Nie znaleziono wyników',
    'support.chat': 'Nie możesz znaleźć tego, czego szukasz? Skontaktuj się z naszym',
    'support.chat.with.us': 'Czatem Pomocy Online',
  },
  pt_PT: {
    'consumption.co2': `Emissões ${co2} Combinadas`,
    'consumption.energy': 'Consumo de energia elétrica combinado',
    'consumption.fuel': 'Consumo de combustível combinado',
    'footnotes.local': '',
    'footnotes.wltp': `Os valores indicados foram determinados de acordo com o método da medição prescrito. São os "valores de ${co2} de WLTP", nos termos do artigo 2, n.º3, do Regulamento de Execução(EU) 2017/1153. Os números/valores não se referem a um veículo individualmente e não são parte da proposta; são fornecidos unicamente com o objetivo de ajudar na comparação entre diferentes modelos de veículos automóveis. Estes valores variam consoante os extras opcionais escolhidos.O consumo de energia e a autonomia foram calculados com base no Regulamento 692/2008/CE.O consumo de energia e a autonomia dependem da configuração do veículo.`,
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': `Para mais informação sobre dados oficiais de consumo e emissões de ${co2} de automóveis ligeiros de passageiros, por favor contacte o seu Concessionário Oficial Mercedes-Benz.`,
    'search.input.label': 'Termo de pesquisa / Configurador código online',
    'search.result.buy-online': 'Comprar online',
    'search.results': 'Sem resultados. | {count} Resultado de pesquisa | {count} Resultados de pesquisa',
    'search.results.count': ' {count} Resultados de pesquisa',
    'search.results.backup': 'Não foram encontrados dados semelhantes. Ver páginas semelhantes:',
    'search.results.none.summary':
      'Não existem resultados de pesquisa relacionados com este termos. Por favor tente novamente com um termo diferente.',
    'search.show-more': 'Mostrar mais',
    'search.unavailable': 'A pesquisa não está disponível.',
    'search.result.new': 'Novo',

    'input.placeholder': 'Termo de pesquisa / Configurador código online',

    'suggestions.all_search_results': 'Todos os resultados da pesquisa',
    'suggestions.all_search_results_for': 'Mostrar todos os resultados de',
    'suggestions.in': 'em',

    all: 'Todos',
    UCOS: 'Online Store de veículos usados',
    PASSENGER_CARS: 'Veículos ligeiros de passageiros',
    VANS: 'Furgões',
    NCOS: 'Online Store de veículos novos',
    VIDEO: 'Vídeos',
    DEALER_LOCATOR: 'Pesquisa de concessionários',
    CONFIGURATOR: 'Mercedes-Benz Car Configurator',
    TEST_DRIVE: 'Prova de estrada',
    VEHICLE_SEARCH: 'Pesquisa de veículos usados',
    COLLECT: 'Collection e acessórios',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'Acessórios de carro',

    'search.result.consumption': 'Consumo',
    'watch.video': 'Ver o vídeo',
    'input.recently': 'Pesquisas recentes',
    'input.help.title': 'O que deve procurar?',
    'input.help.text':
      'Pesquise através dos tipos de veículos, modelos, códigos de configuração ou por acessórios, outros produtos e informações',

    // No results
    'support.check': 'Verifique se há erros de escrita ou tente novamente com um termo diferente.',
    'support.no.results': 'Não há resultados de pesquisa disponíveis para este termo de pesquisa.',
    'support.no.results.term': 'Nenhum resultado encontrado',
    'support.chat': 'Não consegue encontrar o que procura? Por favor, use o nosso',
    'support.chat.with.us': 'Suporte Online-Chat',
  },
  es_ES: {
    'consumption.co2': `${co2} Emisiones combinadas`,
    'consumption.energy': 'Consumo combinado eléctrico',
    'consumption.fuel': 'Consumo combinado de combustible',
    'footnotes.local': '',
    'footnotes.wltp': `Los valores indicados han sido determinados según el procedimiento de medición prescrito. Se trata de «valores de emisiones de ${co2} WLTP» según el art. 2, apartado 3, del Reglamento de Ejecución (UE) 2017/1153. El consumo de combustible se ha calculado en base a dichos valores. El consumo de corriente se ha determinado sobre la base del Reglamento 683/2008/CE. Los datos no hacen referencia a un vehículo en particular y no forman parte integrante de la oferta, sino que sirven solamente para comparar entre sí los diferentes modelos. Los valores varían en función de los equipos opcionales elegidos.`,
    'footnotes.nedc': '', // `Los valores de ${co2} indicados han sido obtenidos de acuerdo con el procedimiento de ensayo “NEDC ${co2}“ según lo dispuesto en el art. 2 No1 Reglamento de aplicación (UE) 2017/1153.`
    'footnotes.emissions.appendix': '', // `Los datos no se refieren a un vehículo en particular y no forman parte de una oferta, sino que únicamente sirven para establecer comparativas entre distintos modelos. Para más información acerca del consumo de combustible oficial y de las emisiones de ${co2} se puede consultar la 'Guía de consumo de combustible y emisiones de ${co2} de nuevos vehículos' que está disponible sin coste en todos los puntos de venta y en IDAE en www.idae.es.`,
    'search.input.label': 'Tu búsqueda / Código online del configurador',
    'search.result.buy-online': 'Compra online',
    'search.results': 'No se han encontrado resultados | {count} resultado | {count} resultados',
    'search.results.count': ' {count} resultados',
    'search.results.backup': 'No se han encontrado coincidencias exactas. Ver páginas relacionadas:',
    'search.results.none.summary':
      'No hay resultados disponibles para este término de búsqueda. Inténtalo de nuevo con otro término de búsqueda.',
    'search.show-more': 'Ver más resultados',
    'search.unavailable': 'La búsqueda no está disponible actualmente.',
    'search.result.new': 'Nuevo',
    'input.placeholder': 'Tu búsqueda / Código online del configurador',

    'suggestions.all_search_results': 'Todos los resultados de búsqueda',
    'suggestions.all_search_results_for': 'Mostrar todos los resultados para',
    'suggestions.in': 'en',

    all: 'Todos',
    UCOS: 'Tienda en línea de autos usados',
    PASSENGER_CARS: 'Automóviles',
    VANS: 'Vans',
    NCOS: 'Tienda online de coches nuevos',
    VIDEO: 'vídeos',
    DEALER_LOCATOR: 'Búsqueda de concesionarios',
    CONFIGURATOR: 'Configurador',
    TEST_DRIVE: 'Prueba de conducción',
    VEHICLE_SEARCH: 'Búsqueda de vehículos',
    COLLECT: 'Accesorios y coleccionables',
    CONNECT: 'Tienda Mercedes me',
    ACCESSORIES: 'Accesorios de coche',

    'search.result.consumption': 'Consumo',
    'watch.video': 'Vea el vídeo',
    'input.recently': 'Buscado recientemente',
    'input.help.title': '¿Qué puedes buscar?',
    'input.help.text':
      'Puedes realizar búsquedas indicando el tipo de vehículo, el modelo, códigos de configuración o bien buscar accesorios, otros productos e información',

    // No results found
    'support.check':
      'Comprueba que no has cometido errores de ortografía, o inténtalo de nuevo con un término diferente.',
    'support.no.results': 'No hay resultados disponibles para este término de búsqueda.',
    'support.no.results.term': 'No se ha encontrado ningún resultado',
    'support.chat': '¿No has encontrado lo que estabas buscando? Acude a nuestro servicio de asistencia por',
    'support.chat.with.us': 'conversación online',
  },
  es_MX: {
    'consumption.co2': `${co2} emisiónes combinadas`,
    'consumption.energy': 'Consumo de potencia en ciclo de prueba combinado',
    'consumption.fuel': 'Consumo energético combinado',
    'footnotes.local': '',
    'footnotes.wltp': `En cumplimiento con las normas mexicanas aplicables. El alcance de
la presente información referente al rendimiento de combustible, relaciona valores obtenidos en condiciones controladas, las cuales pueden variar derivado de las condiciones ambientales, orografía, calidad del combustible, así como operación del vehículo automotor.`,
    'footnotes.nedc':
      'En cumplimiento con las normas mexicanas aplicables. El alcance de la presente información referente al rendimiento de combustible, relaciona valores obtenidos en condiciones controladas, las cuales pueden variar derivado de las condiciones ambientales, orografía, calidad del combustible, así como operación del vehículo automotor.', // `Los valores de ${co2} indicados han sido obtenidos de acuerdo con el procedimiento de ensayo “NEDC ${co2}“ según lo dispuesto en el art. 2 No1 Reglamento de aplicación (UE) 2017/1153.`
    'footnotes.emissions.appendix':
      'Para obtener más información sobre el consumo oficial de combustible y las emisiones de CO2 de autos de pasajeros, contacta tu distribuidor autorizado Mercedes-Benz.', // `Los datos no se refieren a un vehículo en particular y no forman parte de una oferta, sino que únicamente sirven para establecer comparativas entre distintos modelos. Para más información acerca del consumo de combustible oficial y de las emisiones de ${co2} se puede consultar la 'Guía de consumo de combustible y emisiones de ${co2} de nuevos vehículos' que está disponible sin coste en todos los puntos de venta y en IDAE en www.idae.es.`,
    'search.input.label': 'Término buscado/OnlineCode Configurator',
    'search.result.buy-online': 'Compra online',
    'search.results': 'Resultados no encontrados | {count} resultado | {count} resultados',
    'search.results.count': ' {count} resultados',
    'search.results.backup': 'No se han encontrado coincidencias exactas. Ver páginas relacionadas:',
    'search.results.none.summary':
      'No hay resultados disponibles para este término de búsqueda. Inténtalo de nuevo con otro término de búsqueda.',
    'search.show-more': 'Mostrar más',
    'search.unavailable': 'Búsqueda no disponible actualmente.',
    'search.result.new': 'Nuevo',

    didyoumean: '¿Quisiste decir?',
    all: 'Todos',
    configurator: 'Configurador',
    collect: 'Collection y Accesorios',
    connect: 'Mercedes me Store',
    ncos: 'New Cars Online Store ',
    ucos: 'Used Cars Online Store',
    dealer_locator: 'Localizador de Distribuidores',
    passenger_cars: 'Autos de pasajeros',
    test_drive: 'Prueba de manejo',
    vans: 'Vanes',
    vehicles_search: 'Búsqueda de vehículos',
    video: 'Video',
    related_search: 'Búsquedas relacionadas',
    ACCESSORIES: 'Accesorios de coche',

    'search.result.consumption': 'Consumo',
    'watch.video': 'Vea el vídeo',
    'input.recently': 'Buscado recientemente',
    'input.help.title': '¿Qué puedes buscar?',
    'input.help.text':
      'Puedes realizar búsquedas indicando el tipo de vehículo, el modelo, códigos de configuración o bien buscar accesorios, otros productos e información',

    'input.placeholder': 'Tu búsqueda / Código online del configurador',

    // No results found
    'support.check':
      'Comprueba que no has cometido errores de ortografía, o inténtalo de nuevo con un término diferente.',
    'support.no.results': 'No hay resultados disponibles para este término de búsqueda.',
    'support.no.results.term': 'No se ha encontrado ningún resultado',
    'support.chat': '¿No has encontrado lo que estabas buscando? Acude a nuestro servicio de asistencia por',
    'support.chat.with.us': 'conversación online',
  },
  en_AU: {
    ...englishMessages,
  },
  en_NZ: {
    ...englishMessages,
  },
  ro_RO: {
    'consumption.co2': `${co2} emisii combinate`,
    'consumption.energy': 'Consum de energie în ciclu de test combinat',
    'consumption.fuel': 'Consum de combustibil combinat',
    'footnotes.local': '',
    'footnotes.wltp': `Valorile comunicate au fost stabilite conform procedurilor de măsurare impuse. Este vorba de „valorile ${co2} WLTP“ în sensul art. 2 nr. 3 din Regulamentul de punere în aplicare (UE) 2017/1153. Valorile consumului de combustibil au fost calculate pe baza acestor valori. Consumul de curent a fost determinat pe baza Regulamentului 683/2008/CE. Informațiile nu se referă la un autovehicul individual și nu sunt parte integrantă a ofertei, ci servesc exclusiv în scopul comparației între diferite modele de autovehicule. Valorile variază în funcție de echipările speciale alese.`,
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': `Pentru mai multe informații despre consumul oficial de combustibil și emisiile de ${co2} ale autoturismelor noi, vă rugăm să contactați partenerul dumneavoastră autorizat Mercedes-Benz.`,
    'search.input.label': 'Termenul dumneavoastră de căutare / Configurator OnlineCode',
    'search.result.buy-online': 'Magazin Online',
    'search.results': 'Nu s-au găsit rezultate. | {count} rezultatul căutării | {count} rezultatele căutării',
    'search.results.count': '{count} rezultatele căutării',
    'search.results.backup': 'Nu s-au găsit rezultate exacte. Vizualizați paginile asociate:',
    'search.results.none.summary':
      'Pentru acest termen de căutare nu s-au găsit rezultate. Vă rugăm să încercați din nou cu un alt termen.',
    'search.show-more': 'Arată mai mult',
    'search.unavailable': 'Căutarea nu este disponibilă.',
    'search.result.new': 'Nou',
    'search.result.consumption': 'Consum',

    'input.placeholder': 'Termenul dumneavoastră de căutare / Configurator OnlineCode',

    'suggestions.all_search_results': 'Toate rezultatele căutării',
    'suggestions.all_search_results_for': 'Afișează toate rezultatele pentru',
    'suggestions.in': 'în',

    all: 'Alle',
    UCOS: 'Brugte biler onlinebutik',
    PASSENGER_CARS: 'Personbil',
    VANS: 'MPV',
    NCOS: 'Nye biler onlinebutik',
    VIDEO: 'Videoer',
    DEALER_LOCATOR: 'Forhandlersøgning',
    CONFIGURATOR: 'Mercedes-Benz Car Configurator',
    TEST_DRIVE: 'Prøvetur',
    VEHICLE_SEARCH: 'Søgning efter brugt bil',
    COLLECT: 'Collection & tilbehør',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'Biltilbehør',

    'watch.video': 'Urmăriți videoclipul',
    'input.recently': 'Căutate recent',
    'input.help.title': 'Ce trebuie să cauți?',
    'input.help.text':
      'Caută folosind modele de autovehicule, coduri de configurare sau de accesorii, alte produse și informații',

    'search.result.grid': 'Grilă',
    'search.result.list': 'Listă',

    // No results
    'support.check':
      'Vă rugăm să verificați dacă există greșeli de ortografie sau să încercați cu un alt termen de căutare.',
    'support.no.results': 'Nu există rezultate ale căutării disponibile pentru acest termen de căutare.',
    'support.no.results.term': 'Nu s-au găsit rezultate',
    'support.chat': 'Nu găsiți ceea ce căutați? Vă rugăm să folosiți varianta noastră de',
    'support.chat.with.us': 'asistență online',
  },
  it_IT: {
    'consumption.co2': `Emissioni ${co2} ciclo misto`,
    'consumption.energy': 'Consumo di energia elettrica ciclo misto',
    'consumption.fuel': 'Consumo di carburante ciclo misto',
    'footnotes.local': '',
    'footnotes.wltp': `I valori di consumo carburante e autonomia sono stati rispettivamente rilevati: per il carburante, con le tecniche di misurazione della metodologia WLTP ai sensi del Regolamento di esecuzione (UE) 2017/1153 nella sua versione in vigore; per l’energia, ai sensi del Regolamento (UE) 683/2008. I valori dipendono dalla configurazione dell'auto.`,
    'footnotes.nedc': `I valori indicati sono stati rilevati in base al procedimento di misurazione prescritto. Si tratta dei "valori di ${co2} NEDC" ai sensi dell' art. 2 n. 1 del Regolamento di Esecuzione (UE) 2017/1153. I consumi di carburante sono stati calcolati sulla base di tali valori. I dati non si riferiscono ad un singolo veicolo e non sono parte integrante dell'offerta, ma sono forniti esclusivamente a titolo di confronto tra i diversi modelli. I valori variano a seconda degli equipaggiamenti a richiesta dei singoli veicoli.`,
    'footnotes.emissions.appendix': `Per maggiori informazioni sui dati ufficiali di consumo  carburante ed emissioni di ${co2} di veicoli nuovi si rimanda alla «Guida al risparmio di carburante, emissioni di C02 e consumo energetico», disponibile gratuitamente presso la rete di vendita MB e sul sito web del Ministero dello sviluppo economico.`,
    'search.input.label': 'La tua ricerca/ "OnlineCode Configurator"',
    'search.result.buy-online': 'Showroom Online',
    'search.results': 'Nessun risultato trovato. | {count} Risultato di ricerca | {count} Risultati di ricerca ',
    'search.results.count': '{count} Risultati di ricerca',
    'search.results.backup': 'Nessun risultato di ricerca. Vedi pagine correlate:',
    'search.results.none.summary':
      'Non è disponibile nessun risultato con questa chiave di ricerca. Per favore riprovare con un termine diverso.',
    'search.show-more': 'Mostra di più',
    'search.unavailable': 'La ricerca non è disponibile attualmente.',
    'search.result.new': 'Nuova',
    'input.placeholder': 'La tua ricerca/ "OnlineCode Configurator"',

    'search.result.consumption': 'Consumi',
    'watch.video': 'Guarda il video',
    'input.recently': 'Ricerche recenti',
    'input.help.title': 'Cosa dovresti cercare?',
    'input.help.text':
      'Effettua la ricerca utilizzando tipi di veicoli, modelli, codici di configurazione oppure accessori, altri prodotti e altre informazionion',

    all: 'Tutte',
    UCOS: 'Modelli usati',
    PASSENGER_CARS: 'Autovettura',
    VANS: 'Monovolume',
    NCOS: 'Scegli in pronta consegna',
    VIDEO: 'Video',
    DEALER_LOCATOR: 'Ricerca concessionaria',
    CONFIGURATOR: 'Cofiguratore vetture Mercedes-Benz',
    TEST_DRIVE: 'Test drive',
    VEHICLE_SEARCH: 'Ricerca vetture usate',
    COLLECT: 'Collezione & Accessori',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'Accessori per auto',

    'search.result.grid': 'Griglia',
    'search.result.list': 'Elenco',

    // No results
    'support.check': 'Correggi eventuali errori di battitura oppure riprova con un termine diverso.',
    'support.no.results': 'La ricerca non ha prodotto risultati con questo termine.',
    'support.no.results.term': 'Nessun risultato trovato',
    'support.chat': 'Non trovi ciò che cerchi? Rivolgiti alla nostra assistenza ',
    'support.chat.with.us': 'online via chat',
  },
  fr_FR: {
    'consumption.co2': `${co2} emissions combined`,
    'consumption.energy': 'Power consumption in combined test cycle',
    'consumption.fuel': 'Fuel consumption combined',
    'footnotes.local': '',
    'footnotes.wltp': '',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Votre recherche/OnlineCode ',
    'search.result.buy-online': 'Buy Online',
    'search.results': 'Aucun résultat trouvé | {count} Résultat | {count} Résultats',
    'search.results.count': '{count} Résultats',
    'search.results.backup': "Nous n'avons pas trouvé résultats. Voir les pages similaires",
    'search.results.none.summary': "Aucun résultat n'a été trouvé. Veuillez réessayer avec un autre terme.",
    'search.show-more': 'Voir plus',
    'search.unavailable': 'La recherche est momentanément indisponible',
    'search.result.new': 'Nouveau',
    'input.placeholder': 'Votre recherche/OnlineCode',

    'suggestions.all_search_results': 'Tous les résultats de recherche',
    'suggestions.all_search_results_for': 'Afficher tous les résultats pour',
    'suggestions.in': 'dans',

    all: 'Tous',
    UCOS: "Boutique en ligne véhicules d'occasion",
    PASSENGER_CARS: 'VP',
    VANS: 'Vans',
    NCOS: 'Boutique en ligne véhicules neufs',
    VIDEO: 'Vidéos',
    DEALER_LOCATOR: 'Recherche de distributeur',
    CONFIGURATOR: 'Configurateur Mercedes-Benz',
    TEST_DRIVE: 'Essai sur route',
    VEHICLE_SEARCH: 'Recherche de véhicules d’occasion',
    COLLECT: 'Collection et accessoires',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'Accessoires de voiture',

    'search.result.consumption': 'Consommation',
    'watch.video': 'Regarder la vidéo',
    'input.recently': 'Récemment recherché',
    'input.help.title': 'Regarder la vidéo?',
    'input.help.text':
      "Rechercher par types de véhicules, modèles, codes de configuration ou rechercher des accessoires, d'autres produits et informations",

    'search.result.grid': 'Grille',
    'search.result.list': 'Liste',

    // No results
    'support.check': "Veuillez vérifier l'orthographe ou essayer avec un autre terme.",
    'support.no.results': "Aucun résultat n'est disponible pour ce terme recherché.",
    'support.no.results.term': 'Aucun résultat trouvé',
    'support.chat': 'Vous ne trouvez pas ce que vous cherchez ?Veuillez utiliser notre assistance en',
    'support.chat.with.us': 'ligne ou par messagerie instantanée.',
  },
  de_CH: germanMessages,
  fr_CH: {
    'consumption.co2': `${co2} émissions combinées`,
    'consumption.energy': "Consommation d'énergie",
    'consumption.fuel': 'Consommation de carburant combinée',
    'footnotes.local': '',
    'footnotes.wltp': `La consommation normalisée de carburant/d'électricité est calculée selon la méthode de mesure 715/2007/CEE dans sa version actuellement en vigueur. Les valeurs indiquées relatives à la consommation d?énergie et aux émissions de ${co2} sont des valeurs suisses et se basent sur la réception par type. Il s'agit ici de valeurs qui ont été déterminées dans le cycle de mesure WLTP. Dans la pratique, les valeurs de consommation peuvent cependant diverger des valeurs indiquées, en fonction du style de conduite ainsi que des conditions de la chaussée, du trafic, des influences de l?environnement et de l?état du véhicule. Les données ne se réfèrent pas à un véhicule précis et ne font pas partie de l'offre, mais servent uniquement à la comparaison entre les différents types de véhicules. Afin que les consommations d?énergie des différentes motorisations (essence, diesel, gaz, électricité, etc.) soient comparables, elles sont indiquées en sus sous la forme d'équivalents essence (unité de mesure pour l'énergie). Le ${co2} est le principal gaz à effet de serre responsable du réchauffement climatique; les émissions moyennes de ${co2} de tous les types de véhicules offerts (quelle que soit la marque) s'élèvent à 169 g/km pour l'année 2021.`,
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': `Weitere Informationen über den offiziellen Kraftstoffverbrauch und die ${co2}-Emissionen neuer Personenkraftwagen erhalten Sie bei Ihrem Mercedes-Benz Vertragshändler.`,
    'search.input.label': 'Votre terme de recherche / Configurateur OnlineCode',
    'search.result.buy-online': 'Acheter en Ligne',
    'search.results':
      'Aucun résultat de recherche trouvé | {count} Résultat de la recherche | {count}  Résultats de la recherche',
    'search.results.count': '{count}  Résultats de la recherche',
    'search.results.backup': "Aucune correspondance exacte n'a été trouvée. Voir les pages connexes:",
    'search.results.none.summary':
      "Il n'y a pas de résultats de recherche pour ce terme. Veuillez essayer à nouveau avec un autre terme de recherche.",
    'search.show-more': 'En savoir plus',
    'search.unavailable': "La recherche n'est pas disponible actuellement.",
    'search.result.new': 'Nouveau',

    'input.placeholder': 'Votre terme de recherche / Configurateur OnlineCode',

    'search.result.consumption': 'Consommation',
    'watch.video': 'Regarder la vidéo',
    'input.recently': 'Récemment recherché',
    'input.help.title': 'Que devriez-vous recherchez?',
    'input.help.text':
      "Rechercher par types de véhicules, modèles, codes de configuration ou rechercher des accessoires, d'autres produits et informations",

    all: 'Tous',
    UCOS: "Boutique en ligne véhicules d'occasion",
    PASSENGER_CARS: 'VP',
    VANS: 'Vans',
    NCOS: 'Boutique en ligne véhicules neufs',
    VIDEO: 'Vidéos',
    DEALER_LOCATOR: 'Recherche de distributeur',
    CONFIGURATOR: 'Configurateur Mercedes-Benz',
    TEST_DRIVE: 'Essai sur route',
    VEHICLE_SEARCH: 'Recherche de véhicules d’occasion',
    COLLECT: 'Collection et accessoires',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'Accessoires de voiture',

    'search.result.grid': 'Grille',
    'search.result.list': 'Liste',

    // No results
    'support.check': "Veuillez vérifier les fautes d'orthographe ou réessayer avec une autre phrase",
    'support.no.results': "Aucun résultat de recherche n'est disponible pour ce terme de recherche.",
    'support.no.results.term': 'Aucun résultat',
    'support.chat': 'Vous ne trouvez pas ce que vous cherchez? Veuillez utiliser notre ',
    'support.chat.with.us': 'support de chat en ligne.',
  },
  it_CH: {
    'consumption.co2': `${co2} emissioni combinate`,
    'consumption.energy': 'Consumo di energia nel ciclo di prova combinato',
    'consumption.fuel': 'Consumo di carburante combinato',
    'footnotes.local': '',
    'footnotes.wltp': `Il consumo di carburante/corrente è misurato secondo la normativa 715/2007/CE come modificata dalla versione attualmente in vigore. I valori indicati relativi al consumo di energia e alle emissioni di ${co2} sono valori svizzeri sulla base dell'omologazione. Si tratta di valori che sono stati rilevati nell'ambito del ciclo di misurazione WLTP. I consumi possono variare a seconda dello stile di guida, delle condizioni del fondo stradale e del traffico, delle condizioni meteorologiche e dello stato della vettura. I dati non si riferiscono a una singola vettura e non fanno parte dell'offerta, ma sono forniti esclusivamente a titolo di confronto tra i diversi modelli. Per rendere paragonabili i consumi di energia dei diversi tipi di motori (benzina, gasolio, gas, corrente ecc.), sono riportati anche i cosiddetti equivalenti benzina (unità di misura per l'energia). Il ${co2} è il gas a effetto serra maggiormente responsabile del riscaldamento della Terra; per il 2021 l'emissione media di ${co2} di tutti i modelli proposti (per tutti i marchi) è di 169 g/km.`,
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': `Weitere Informationen über den offiziellen Kraftstoffverbrauch und die ${co2}-Emissionen neuer Personenkraftwagen erhalten Sie bei Ihrem Mercedes-Benz Vertragshändler.`,
    'search.input.label': 'Il vostro termine di ricerca / OnlineCode Configurator',
    'search.result.buy-online': 'Acquista Online',
    'search.results': 'Nessun risultato trovato. | {count}  Risultato della ricerca | {count}  Risultati della ricerca',
    'search.results.count': '{count}  Risultati della ricerca',
    'search.results.backup': 'Non sono state trovate corrispondenze esatte. Visualizza le pagine correlate:',
    'search.results.none.summary':
      'Non ci sono risultati di ricerca disponibili per questo termine di ricerca. Riprovare con un termine diverso.',
    'search.show-more': 'Mostra di più',
    'search.unavailable': 'La ricerca non è attualmente disponibile.',
    'search.result.new': 'Nuovo',

    'input.placeholder': 'Il vostro termine di ricerca / OnlineCode Configurator',

    'search.result.consumption': 'Consumi',
    'watch.video': 'Guarda il video',
    'input.recently': 'Ricerche recenti',
    'input.help.title': 'Cosa dovresti cercare?',
    'input.help.text':
      'Effettua la ricerca utilizzando tipi di veicoli, modelli, codici di configurazione oppure accessori, altri prodotti e altre informazionion',

    all: 'Tutte',
    UCOS: 'Modelli usati',
    PASSENGER_CARS: 'Autovettura',
    VANS: 'Monovolume',
    NCOS: 'Scegli in pronta consegna',
    VIDEO: 'Video',
    DEALER_LOCATOR: 'Ricerca concessionaria',
    CONFIGURATOR: 'Cofiguratore vetture Mercedes-Benz',
    TEST_DRIVE: 'Test drive',
    VEHICLE_SEARCH: 'Ricerca vetture usate',
    COLLECT: 'Collezione & Accessori',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'Accessoires de voiture',

    'search.result.grid': 'Grid',
    'search.result.list': 'List',

    // No results
    'support.check': "Veuillez vérifier les fautes d'orthographe ou réessayer avec une autre frase",
    'support.no.results': "Aucun résultat de recherche n'est disponibile pour ce terme de recherche.",
    'support.no.results.term': 'Aucun risultato',
    'support.chat': 'Vous ne trouvez pas ce que vous cherchez? Veuillez utente non supporta la',
    'support.chat.with.us': 'chat in linea.',
  },
  sk_SK: {
    'consumption.co2': `Emisie ${co2} kombinované`,
    'consumption.energy': 'Kombinovaná spotreba elektrickej energie',
    'consumption.fuel': 'Spotreba paliva kombinovaná',
    'footnotes.local': '',
    'footnotes.wltp': `Uvedené hodnoty boli zistené podľa predpísaného spôsobu merania. Ide o „hodnoty ${co2} podľa skúšobného postupu WLTP“ v zmysle čl. 2 č. 3 vykonávacieho nariadenia (EÚ) 2017/1153. Hodnoty spotreby paliva boli vypočítané na základe týchto hodnôt. Spotreba elektrického prúdu bola zistená na základe nariadenia 683/2008/ES. Údaje sa nevzťahujú na konkrétne vozidlo a nie sú súčasťou ponuky. Slúžia len na porovnanie rôznych typov vozidiel. Hodnoty sa líšia v závislosti od zvolených prvkov mimoriadnej výbavy.`,
    'footnotes.nedc': `Uvedené hodnoty boli zistené podľa predpísaného spôsobu merania. Ide o „hodnoty ${co2} podľa NEDC“ v zmysle čl. 2, bodu 1 vykonávacieho nariadenia (EÚ) 2017/1153. Údaje sa nevzťahujú na konkrétne vozidlo a nie sú súčasťou ponuky, ale slúžia len na porovnanie rôznych typov vozidiel. Hodnoty sa líšia v závislosti od zvolených prvkov mimoriadnej výbavy.`,
    'footnotes.emissions.appendix': `Pre viac informácií ohľadom oficiálnych hodnôt spotrieb a emisií ${co2} osobných vozidiel vás prosíme aby ste kontaktovali vášho autorizovaného partnera Mercedes-Benz.`,
    'search.input.label': 'Vami vyhľadávaný pojem / Online kód konfigurátora',
    'search.result.buy-online': '',
    'search.results.count': '{count} výsledkov vyhľadávania',
    'search.results':
      'Nenašli sme žiaden výsledok. | {count} výsledok vyhľadávania | {count} výsledky vyhľadávania | {count} výsledkov vyhľadávania',
    'search.results.backup': 'Nenašli sme žiaden presný výsledok. Pozrite si súvisiace stránky:',
    'search.results.none.summary':
      'Pre vami vyhľadávaný pojem sme nenašli žiaden výsledok. Vyhľadávanie, prosím, zopakujte s iným pojmom.',
    'search.show-more': 'Zobraziť viac',
    'search.unavailable': 'Vyhľadávanie momentálne nie je k dispozícii.',
    'search.result.new': 'Novinka',

    'input.placeholder': 'Vami vyhľadávaný pojem / Online kód konfigurátora',

    'suggestions.all_search_results': 'Všetky výsledky vyhľadávania',
    'suggestions.all_search_results_for': 'Zobraziť všetky výsledky pre',
    'suggestions.in': 'v',

    all: 'Všetky',
    UCOS: 'Jazdené vozidlá | Onlinový obchod',
    PASSENGER_CARS: 'Osobné vozidlá',
    VANS: 'Transportéry',
    NCOS: 'Nové vozidlá | Onlinový obchod',
    VIDEO: 'Videá',
    DEALER_LOCATOR: 'Vyhľadávanie obchodníka',
    CONFIGURATOR: 'Konfigurátor vozidiel Mercedes-Benz',
    TEST_DRIVE: 'Predvádzacia jazda',
    VEHICLE_SEARCH: 'Vyhľadávanie vozidiel',
    COLLECT: 'Kolekcia a príslušenstvo',
    CONNECT: 'Obchod Mercedes me',
    ACCESSORIES: 'Autopríslušenstvo',

    'search.result.consumption': 'Spotreba',
    'watch.video': 'Pozrite si video',
    'input.recently': 'Nedávno vyhľadávané',
    'input.help.title': 'Čo by ste mali hľadať?',
    'input.help.text':
      'Vyhľadávajte podľa typov vozidiel, modelov, kódov konfigurácií alebo vyhľadávajte príslušenstvo, ostatné produkty a informácie',

    'search.result.grid': 'Mriežka',
    'search.result.list': 'Zoznam',

    // No results
    'support.check': 'Skontrolujte, prosím, či nedošlo k preklepu alebo to skúste znova s iným výrazom.',
    'support.no.results': 'Pre tento hľadaný výraz nie sú k dispozícii žiadne výsledky vyhľadávania.',
    'support.no.results.term': 'Nenašli sa žiadne výsledky',
    'support.chat': 'Neviete nájsť to, čo hľadáte? Využite, prosím, našu',
    'support.chat.with.us': 'online chatovú podporu.',
  },
  fr_CA: {
    ...englishMessages,
    'input.placeholder': 'Votre recherche/OnlineCode',

    'search.result.consumption': 'Consommation',
    'watch.video': 'Regarder la vidéo',
    'input.recently': 'Récemment recherché',
    'input.help.title': 'Que devriez-vous recherchez ?',
    'input.help.text':
      "Rechercher par types de véhicules, modèles, codes de configuration ou rechercher des accessoires, d'autres produits et informations",

    'search.result.grid': 'Grille',
    'search.result.list': 'Liste',
  },
  en_CA: englishMessages,
  en_ID: englishMessages,
  en_IN: englishMessages,
  en_MY: {
    ...englishMessages,
    'search.result.buy-online': 'Virtual Showroom',
  },
  en_SG: englishMessages,
  en_TH: englishMessages,
  th_TH: {
    'consumption.co2': `การปลดปล่อยก๊าซ${co2} รวมกัน`,
    'consumption.energy': 'การใช้พลังงานต่อรอบการทดลอง',
    'consumption.fuel': 'การสิ้นเปลืองเชื้อเพลิงทั้งหมดรวมกัน',
    'footnotes.local': '',
    'footnotes.wltp': '',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix':
      'สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการสิ้นเปลืองเชื้อเพลิง และการปลดปล่อยก๊าซ CO2 ของรถยนต์ กรุณาติดต่อผู้จำหน่ายเมอร์เซเดส-เบนซ์อย่างเป็นทางการ',
    'search.input.label': 'ค้นหา',
    'search.result.buy-online': 'ซื้อรถออนไลน์',
    'search.results': 'ไม่พบข้อมูล | {count} ผลการค้นหา | {count} ผลการค้นหา',
    'search.results.backup': 'ไม่พบข้อมูลที่ตรงตามการค้นหา พบเนื้อหาใกล้เคียงด้านล่าง:',
    'search.results.none.summary': 'ไม่พบข้อมูลสำหรับการการค้นหานี้ กรุณาลองใหม่อีกครั้ง',
    'search.results.count': '{count} ผลการค้นหา',
    'search.show-more': 'แสดงผลเพิ่มเติม',
    'search.unavailable': 'การค้นหาไม่สามารถใช้งานได้ในขณะนี้',
    'search.result.new': 'ใหม่',
    'input.placeholder': 'ค้นหา',

    'suggestions.all_search_results': 'ผลลัพธ์การค้นหาทั้งหมด',
    'suggestions.all_search_results_for': 'แสดงผลลัพธ์ทั้งหมดสำหรับ',
    'suggestions.in': 'ใน',

    all: 'ทั้งหมด',
    UCOS: 'ร้านค้าออนไลน์สำหรับรถยนต์มือสอง',
    PASSENGER_CARS: 'รถยนต์ส่วนบุคคล',
    VANS: 'รถตู้',
    NCOS: 'ร้านค้าออนไลน์สำหรับรถยนต์ใหม่',
    VIDEO: 'วิดีโอ',
    DEALER_LOCATOR: 'การค้นหาตัวแทนจำหน่าย',
    CONFIGURATOR: 'ตัวกำหนดค่ารถยนต์ Mercedes-Benz',
    TEST_DRIVE: 'ทดลองขับ',
    VEHICLE_SEARCH: 'ค้นหารถยนต์มือสอง',
    COLLECT: 'คอลเลกชันและอุปกรณ์ตกแต่ง',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'อุปกรณ์ตกแต่งรถยนต์',

    'search.result.consumption': 'อัตราการสิ้นเปลือง',
    'watch.video': 'รับชมวิดีโอ',
    'input.recently': 'ที่ค้นหาล่าสุด',
    'input.help.title': 'คุณควรค้นหาจากอะไร?',
    'input.help.text': 'ค้นหาโดยระบุประเภทรถยนต์ รุ่นรถยนต์ รหัสการกำหนดค่า หรืออุปกรณ์เสริม ผลิตภัณฑ์และข้อมูลอื่นๆ',

    'search.result.grid': 'ตาราง',
    'search.result.list': 'รายการ',

    // No results
    'support.check': 'โปรดตรวจสอบดูว่าสะกดผิดหรือไม่ หรือลองอีกครั้งโดยใช้คำอื่น',
    'support.no.results': 'คำค้นนี้ไม่มีผลลัพธ์ที่ใช้ได้',
    'support.no.results.term': 'ไม่พบผลลัพธ์',
    'support.chat': 'หากไม่พบสิ่งที่ต้องการค้นหา โปรดใช้ช่องทางช่วยเหลือผ่านการแช',
    'support.chat.with.us': 'ทออนไลน์ของเรา.',
  },
  en_IE: {
    ...englishMessages,
    'footnotes.local':
      'Fuel Consumption Combined and CO2 Emissions Combined.  Vehicles will be charged the NOx levy based as part of VRT based on the COC of that specific vehicle and this may differ from above. The CO2 emissions displayed may differ depending on which options are selected for the vehicle. A change in CO2 emissions could result in a change in vehicle registration tax (VRT). Please consult your retailer for further information on the CO2 emissions.',
    'footnotes.wltp':
      'The indicated values were determined according to the prescribed measurement method - Worldwide Harmonised Light Vehicle Test Procedure (WLTP). Figures shown may include options which are not available in Ireland. WLTP CO2 values will be effective from 1st April 2020. Additionally [a] For Battery Electric Vehicles (BEV) figures determined with battery fully charged. These models require mains electricity for charging. [b] For Plug-in Hybrid Electric Vehicle (PHEV) figures determined with the battery fully charged, using a combination of both battery power and fuel. Figures shown are for comparability purposes only. Figures may differ from real life driving results, which will depend upon a number of factors including (a) the starting charge of the battery (b), factory fitted options,(c) ACCESSORIES fitted (post registration), variations in weather, driving styles and vehicle load. Further information about the test used to establish fuel consumption and CO₂ figures can be found at www.mercedes-benz.ie.',
    'footnotes.nedc':
      'The indicated values were determined according to the prescribed measurement method - Worldwide Harmonised Light Vehicle Test Procedure (WLTP). Figures shown may include options which are not available in Ireland. WLTP CO2 values will be effective from 1st April 2020. Additionally [a] For Battery Electric Vehicles (BEV) figures determined with battery fully charged. These models require mains electricity for charging. [b] For Plug-in Hybrid Electric Vehicle (PHEV) figures determined with the battery fully charged, using a combination of both battery power and fuel. Figures shown are for comparability purposes only. Figures may differ from real life driving results, which will depend upon a number of factors including (a) the starting charge of the battery (b), factory fitted options,(c) ACCESSORIES fitted (post registration), variations in weather, driving styles and vehicle load. Further information about the test used to establish fuel consumption and CO₂ figures can be found at www.mercedes-benz.ie.',
    'footnotes.emissions.appendix':
      'Vehicles will be charged the NOx levy based as part of VRT based on the COC of that specific vehicle and this may differ from above. The CO2 emissions displayed may differ depending on which options are selected for the vehicle. A change in CO2 emissions could result in a change in vehicle registration tax (VRT). Please consult your retailer for further information on the CO2 emissions.',
  },
  tr_TR: {
    'consumption.co2': `Ortalama ${co2} emisyonu`,
    'consumption.energy': 'Ortalama elektrik tüketimi',
    'consumption.fuel': 'Ortalama yakıt tüketimi',
    'footnotes.local': '',
    'footnotes.wltp': '',
    'footnotes.nedc': `Belirtilen değerler, öngörülen ölçme yöntemine göre belirlenmiştir. 2017/1153 sayılı uygulama direktifinin (AB) 2. maddesinin 1 numaralı hükmüne göre “NEFZ-${co2} değerleri” söz konusudur. Bilgiler, münferit bir araç ile ilgili olmayıp, bir teklifin parçası değildir; sadece çeşitli araç tipleri arasında karşılaştırma yapma amacına hizmet ederler. Değerler, seçilen özel donanımlara göre farklılık göstermektedir.`,
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Online kod ara / Web sitesinde ara',
    'search.result.buy-online': 'Online Satın Al',
    'search.results': 'Sonuç bulunamadı | {count} arama sonucu | {count} arama sonucu',
    'search.results.backup': 'Aramanızla eşleşen sonuç bulunamadı. İlgili sayfaları inceleyin:',
    'search.results.count': '{count} arama sonucu',
    'search.results.none.summary':
      'Arama teriminizi içeren sonuç bulunamadı. Farklı bir terim ile tekrar aramayı deneyin.',
    'search.show-more': 'Daha fazlasını görüntüle.',
    'search.unavailable': 'Arama fonksiyonu şu anda çalışmıyor.',
    'search.result.new': 'Yeni',

    'input.placeholder': 'Online kod ara / Web sitesinde ara',

    'search.result.consumption': 'Tüketim',
    'watch.video': 'Videoyu izleyin',
    'input.recently': 'Son Arananlar',
    'input.help.title': 'Neyi aramalısınız?',
    'input.help.text':
      'Araç tipleri, modelleri ve yapılandırma kodlarını kullanarak veya aksesuarlar, diğer ürünler ve bilgiler için arama yapın',

    'search.result.grid': 'Izgara',
    'search.result.list': 'Liste',

    // No results
    'support.check': 'Lütfen yazım hatalarını kontrol edin veya farklı bir terimle devam edin.',
    'support.no.results': 'Bu arama terimi için herhangi bir arama sonucu yok.',
    'support.no.results.term': 'Sonuç bulunamadı',
    'support.chat': 'Aradığınızı bulamıyorum? Lütfen Online Sohbet',
    'support.chat.with.us': 'Desteğimizi kullanın',
  },
  hr_HR: {
    'consumption.co2': `${co2} emisije, kombinirano`,
    'consumption.energy': 'Potrošnja el. energije, kombinirano',
    'consumption.fuel': 'Potrošnja goriva, kombinirano',
    'footnotes.local': '',
    'footnotes.wltp':
      'Navedene vrijednosti utvrđene su prema propisanoj metodi mjerenja - Worldwide Harmonized Light Vehicle Test Procedure (WLTP). Prikazane vrijednosti mogu uključivati opcije koje nisu dostupne na tržištu RH. Vrijednosti WLTP CO2 stupit će na snagu od 1. travnja 2020. Dodatno [a] Za električna vozila s baterijama (BEV) vrijednosti s potpuno napunjenom baterijom. Ovi modeli zahtijevaju električnu mrežu za punjenje. [b] Za hibridna električna vozila (PHEV) vrijednosti određene s potpuno napunjenom baterijom, korištenjem kombinacije snage baterije i goriva. Prikazane vrijednosti služe samo radi usporedbe. Vrijednosti se mogu razlikovati od stvarnih rezultata u vožnji, što ovisi o brojnim čimbenicima uključujući (a) početno stanje napunjenosti baterije, (b) tvornički ugrađenu opremu, (c) ugrađenu DODATNU OPREMU (nakon kupnje), varijacije u vremen skim uvjetima, stil vožnje i opterećenje vozila. Dodatne informacije o testu koji se koristi za određivanje potrošnje goriva i vrijednosti CO₂ možete pronaći na www.mercedes-benz.hr.',
    'footnotes.nedc':
      'Prikazane vrijednosti dobivene su u skladu s propisanim mjernim postupkom. To su "NEDC CO2 vrijednosti" prema čl. 2. br. 1. Provedbene uredbe (EU) 2017/1153. Podaci o potrošnji goriva izračunati su na temelju ovih vrijednosti. Potrošnja električne energije određena je na temelju Direktive 692/2008/EZ.',
    'footnotes.emissions.appendix':
      'Za više informacija o potrošnji goriva i CO2 emisijama za nova osobna vozila molimo Vas da kontaktirate ovlaštenog Mercedes-Benz prodajnog partnera.',
    'search.input.label': 'Vaš pojam za pretraživanje / Online kod za konfigurator',
    'search.result.buy-online': 'Kupi Online',
    'search.results.count': 'Pronađeno rezultata: {count}',
    'search.results':
      'Nije pronađen niti jedan rezultat | Pronađeno rezultata: {count} | Pronađeno rezultata: {count} ',
    'search.results.backup': 'Nema točnih podudaranja s vašim upitom. Prikaz vezanih stranica:',
    'search.results.none.summary':
      'Nema rezultata pretraživanja za uneseni upit. Molimo probajte ponovno s drugim upitom.',
    'search.show-more': 'Prikaži više',
    'search.unavailable': 'Pretraživač trenutačno nije dostupan.',
    'search.result.new': 'Novi',
    'input.placeholder': 'Vaš pojam za pretraživanje / Online kod za konfigurator',
    'search.result.consumption': 'Potrošnja',
    'watch.video': 'Pogledaj video',
    'input.recently': 'Nedavne pretrage',
    'input.help.title': 'Što trebate tražiti?',
    'input.help.text':
      'Pretražujte s pomoću tipa vozila, modela, konfiguracijskog koda ili dodatne opreme, drugih proizvoda i informacija',
    'search.result.grid': 'Mreža',
    'search.result.list': 'Popis',
  },
  et_EE: {
    'consumption.co2': `Keskmine ${co2} heide`,
    'consumption.energy': 'Elektrikulu',
    'consumption.fuel': 'Keskmine kütusekulu',
    'footnotes.local': '',
    'footnotes.wltp': `Nimetatud väärtusi käsitleti vastavalt etteantud mõõtmismeetoditele. Tegu on „WLTP ${co2} väärtustega“ artikkel 2 nr 3 rakendusmääruse (EL) 2017/1153 mõistes. Kütusekulu väärtused arvutati nende väärtuste põhjal. Elektrikulu määrati VO 683/2008/EG alusel. Andmed ei käi konkreetse sõiduki kohta ega ole pakkumise osa, vaid on mõeldud üksnes erinevate sõidukitüüpide võrdlemiseks. Väärtused erinevad olenevalt valitud lisavarustusest`,
    'footnotes.nedc':
      'Kütuse- või energiatarbimine, CO2 heitkogused ja sõiduulatus vastavalt määrusele (EL) 2017/1151. Teistsuguste konfiguratsioonide puhul võivad näitajad erineda. Sõiduauto kütuse- või energiakulu ja CO2 heitkoguse hulka mõjutavad ka sõidustiil ning muud tegurid, mis ei ole tehnilist laadi.',
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Otsingusõna',
    'search.result.buy-online': 'Osta veebipoest',
    'search.results': 'Ei leitud ühtegi tulemust | {count} otsingutulemus | {count} otsingutulemust',
    'search.results.count': '{count} otsingutulemust',
    'search.results.backup': 'Ühtegi täpset vastet ei leitud. Vaata sarnaseid tulemusi:',
    'search.results.none.summary': 'Selle otsingusõnaga ei leitud ühtegi tulemust. Palun proovige uuesti. ',
    'search.show-more': 'Näita rohkem',
    'search.unavailable': 'Otsingufunktsioon pole hetkel saadaval.',
    'search.result.new': 'Uus',

    'search.result.consumption': 'uus',

    'input.placeholder': 'Otsingusõna',

    'suggestions.all_search_results': 'Kõik otsingutulemused',
    'suggestions.all_search_results_for': 'Näita kõiki tulemusi',
    'suggestions.in': 'in',

    all: 'Kõik',
    UCOS: 'Kasutatud sõidukite Online Store pood',
    PASSENGER_CARS: 'Sõiduautod',
    VANS: 'Kaubikud',
    NCOS: 'Uute sõidukite Online Store pood',
    VIDEO: 'Videod',
    DEALER_LOCATOR: 'Edasimüüja otsing',
    CONFIGURATOR: 'Mercedes-Benz konfiguraator',
    TEST_DRIVE: 'Proovisõit',
    VEHICLE_SEARCH: 'Kasutatud autode otsing',
    COLLECT: 'Kollektsioon & varustus',
    CONNECT: 'Mercedes me Store pood',

    'watch.video': 'Vaata videot',
    'input.recently': 'Hiljuti otsitud',
    'input.help.title': 'Mida otsida?',
    'input.help.text':
      'Otsige sõidukitüüpide, mudelite, seadistuskoodide või lisaseadmete, muude toodete ja teabe alusel',

    'search.result.grid': 'Ruudustik',
    'search.result.list': 'Loend',

    // Empty result
    'support.check': 'Palun kontrollige õigekirja või proovige mõne teise sõnaga uuesti.',
    'support.no.results': 'Sellele otsingusõnale puuduvad vasted.',
    'support.no.results.term': 'Tulemusi ei leitud.',
    'support.chat': 'Kas te ei leia otsitavat? Palun kasutage meie omasid. ',
    'support.chat.with.us': 'Vestlustugi veebis.',
  },
  fi_FI: {
    'consumption.co2': `${co2}-päästöt yhdistetyt`,
    'consumption.energy': 'Virrankulutus yhdistetyssä testisyklissä',
    'consumption.fuel': 'Polttoaineen kulutus yhdistetty',
    'footnotes.local': '',
    'footnotes.wltp':
      'Ilmoitetut arvot ovat komission täytäntöönpanoasetuksen (EU) 2017/1153 artiklan 2 kohdan 3 mukaisia WLTP-pohjaisia hiilidioksidiarvoja. Polttoaineen kulutusarvot on laskettu näiden arvojen pohjalta. Virrankulutus on määritetty asetuksen (EY) N:o 683/2008 mukaisesti. Tiedot eivät koske yksittäistä autoa eivätkä ole osa tarjousta; tiedot on tarkoitettu vain auttamaan eri automallien vertailussa. Arvot vaihtelevat valittujen lisävarusteiden mukaan.',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Hakusanasi / Konfiguraattorin Online-koodi',
    'search.result.buy-online': 'Osta verkossa',
    'search.results': 'Ei tuloksia | {count} hakutulos | {count} hakutulosta',
    'search.results.count': '{count} hakutulosta',
    'search.results.backup': 'Ei tarkkoja osumia. Katso aiheeseen liittyvät sivut:',
    'search.results.none.summary': 'Tälle termille ei löydy hakutuloksia. Yritä uudelleen syöttämällä eri termi.',
    'search.show-more': 'Näytä lisää',
    'search.unavailable': 'Haku ei ole tällä hetkellä käytettävissä.',
    'search.result.new': 'Uusi',

    'input.placeholder': 'Hakusanasi / Konfiguraattorin Online-koodi',

    'suggestions.all_search_results': 'Kaikki hakutulokset',
    'suggestions.all_search_results_for': 'Näytä kaikki tulokset seuraavalle',
    'suggestions.in': 'kohdassa',

    all: 'Kaikki',
    UCOS: 'Used vehicle Online Store',
    PASSENGER_CARS: 'Henkilöautot',
    VANS: 'Pakettiautot',
    NCOS: 'New vehicle Online Store',
    VIDEO: 'Videot',
    DEALER_LOCATOR: 'Jälleenmyyjähaku',
    CONFIGURATOR: 'Mercedes-Benz-konfiguraattori',
    TEST_DRIVE: 'Koeajo',
    VEHICLE_SEARCH: 'Used Cars',
    COLLECT: 'Collection & Lisävarusteet',
    CONNECT: 'Mercedes me Store',

    'search.result.consumption': 'Kulutus',
    'watch.video': 'Katso video',
    'input.recently': 'Viimeksi haettu',
    'input.help.title': 'Mitä sinun pitäisi etsiä?',
    'input.help.text':
      'Etsi autotyyppejä, malleja, konfiguraatiokoodeja tai lisävarusteita, muita tuotteita ja tietoja.',

    'search.result.grid': 'Ruudukko',
    'search.result.list': 'Luettelo',

    // Empty result
    'support.check': 'Tarkista kirjoitusvirheiden varalta tai yritä uudelleen toisella hakusanalla.',
    'support.no.results': 'Tälle hakusanalle ei ole hakutuloksia.',
    'support.no.results.term': 'Tuloksia ei löytynyt.',
    'support.chat': 'Etkö löydä etsimääsi? Käytä meidän. ',
    'support.chat.with.us': 'Online-chat-tuki.',
  },
  ru_RU: {
    'consumption.co2': 'Выброс CO2',
    'consumption.energy': 'Расход электроэнергии',
    'consumption.fuel': 'Расход топлива смешанный',
    'footnotes.local':
      'Данные по номинальной мощности и номинальному крутящему моменту указаны в соответствии с Директивой (ЕС) № 715/2007 в действующей редакции.',
    'footnotes.wltp': '',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Введите запрос / Код конфигурации',
    'search.result.buy-online': 'Сегодня в продаже',
    'search.results': 'Поиск не дал результатов | Найдено совпадений:  {count}',
    'search.results.count': 'Найдено совпадений:  {count}',
    'search.results.backup': 'Поиск не дал точных совпадений, результаты  ',
    'search.results.none.summary': 'К сожалению, поиск не дал результатов. Пожалуйста, попробуйте изменить запрос.',
    'search.show-more': 'Показать больше',
    'search.unavailable': 'К сожалению, в настоящее время поиск недоступен',
    'search.result.new': 'новый',

    'input.placeholder': 'Введите запрос / Код конфигурации',

    'suggestions.all_search_results': 'Все результаты поиска',
    'suggestions.all_search_results_for': 'Показать все результаты для',
    'suggestions.in': 'в',

    all: 'Все',
    UCOS: 'Интернет-магазин автомобилей с пробегом',
    PASSENGER_CARS: 'Легковые автомобили',
    VANS: 'Малотоннажные автомобили',
    NCOS: 'Интернет-магазин новых автомобилей',
    VIDEO: 'Видео',
    DEALER_LOCATOR: 'Поиск дилера',
    CONFIGURATOR: 'Конфигуратор автомобиля Mercedes-Benz',
    TEST_DRIVE: 'Тест-драйв',
    VEHICLE_SEARCH: 'Поиск автомобилей с пробегом',
    COLLECT: 'Коллекция и аксессуары',
    CONNECT: 'Магазин Mercedes me',

    'search.result.consumption': 'Расход',
    'watch.video': 'Смотреть видео',
    'input.recently': 'Недавно просмотренные',
    'input.help.title': 'Что вам нужно найти?',
    'input.help.text':
      'Поиск по типу автомобиля, модели, коду конфигурации или аксессуаров, другим продуктам и информации',

    'search.result.grid': 'Сетка',
    'search.result.list': 'Список',
  },
  ja_JP: {
    'consumption.co2': '二酸化炭素(CO₂)排出量',
    'consumption.energy': '電力消費率(電気自動車/ハイブリッド車）（国土交通省審査値)',
    'consumption.fuel': '燃料消費率(国土交通省審査値)　WLTCモード',
    'footnotes.local': '',
    'footnotes.wltp':
      'WLTCモードに基づく燃費消費率となります。WLTCモードは、市街地、郊外、高速道路の各走行モードを平均的な使用時間配分で構成した国際的な走行モードです。 市街地モードは、信号や渋滞等の影響を受ける比較的低速な走行を想定し、郊外モードは、信号や渋滞等の影響をあまり受けない走行を想定、高速道路モードは、高速道路等での走行を想定しています。',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': '',
    'search.input.label': '検索',
    'search.result.buy-online': 'オンラインで購入する',
    'search.results': '0件 | {count} 件 | {count} 件',
    'search.results.count': '{count} 件',
    'search.results.backup': '完全に一致するものは見つかりませんでした。関連ページをご覧ください。',
    'search.results.none.summary':
      '検索されたキーワードに該当するものはありませんでした。キーワードを変更して再度検索してください。',
    'search.show-more': 'もっと見る',
    'search.unavailable': '現在、検索はご利用いただけません',
    'search.result.new': 'New',

    'support.check': '誤字脱字を確認するか、別の用語で再試行してください。',
    'support.no.results': 'この検索用語には検索結果がありません。',
    'support.no.results.term': '結果が見つかりません',
    'support.chat': '検索対象が見つかりませんが？オンラインチャットサポー',
    'support.chat.with.us': 'トをご利用ください',

    'input.placeholder': '検索',

    'suggestions.all_search_results': 'すべての検索結果',
    'suggestions.all_search_results_for': 'すべての結果を表示',
    'suggestions.in': '内で',

    all: '全て',
    didyoumean: '이것을 찾으시나요',
    UCOS: '認定中古車検索',
    PASSENGER_CARS: 'Passenger cars',
    VANS: 'Vans',
    NCOS: 'オンラインショールーム',
    VIDEO: '動画',
    DEALER_LOCATOR: 'ディーラー検索',
    CONFIGURATOR: '見積シミュレーション',
    TEST_DRIVE: '試乗予約',
    VEHICLE_SEARCH: '認定中古車検索',
    COLLECT: '純正アクセサリー',
    CONNECT: 'Mercedes me Store',
    ACCESSORIES: 'カーアクセサリー',

    'search.result.consumption': '燃費',
    'watch.video': '動画をご覧ください',
    'input.recently': '最近検索済み',
    'input.help.title': '検索内容は？',
    'input.help.text':
      '車両タイプ、モデル、設定コードを使用して検索するか、アクセサリー、その他の製品及び情報を検索します',

    'search.result.grid': 'グリル',
    'search.result.list': 'リスト',
  },
  pt_BR: {
    'consumption.co2': `Emissões de ${co2} combinadas`,
    'consumption.energy': 'Consumo de energia em um ciclo de teste combinado',
    'consumption.fuel': 'Consumo de combustível combinado',
    'footnotes.local': '',
    'footnotes.wltp': '',
    'footnotes.nedc':
      'Os números apresentados foram obtidos em conformidade com o processo de medição prescrito. Trata-se de "valores de CO2 do NEDC" correspondentes ao Artigo 2, No. 1, do Regulamento de Implementação (UE) 2017/1153. Os dados de consumo de combustível foram calculados com base nesses valores. O consumo elétrico foi determinado de acordo com a Diretriz 692/2008/EC.',
    'footnotes.emissions.appendix':
      'Para obter mais informações oficiais sobre o consumo de combustível e as emissões de CO2 de novos veículos, entre em contato com o concessionário autorizado Mercedes-Benz de sua preferência.',
    'search.input.label': 'Resultados da sua busca / Código Online do configurador',
    'search.result.buy-online': 'Compre Online',
    'search.results': 'Nenhum resultado encontrado | {count} resultado da busca | {count} resultados da busca',
    'search.results.count': '{count} resultados da busca',
    'search.results.backup': 'Nenhum resultado do termo exato foi encontrado. Veja páginas relacionadas:',
    'search.results.none.summary':
      'Nenhum resultado para esse termo foi encontrado. Por favor, tente novamente com um termo diferente.',
    'search.show-more': 'Exibir mais resultados',
    'search.unavailable': 'A busca não está disponível.',
    'search.result.new': 'Novo',
    'input.placeholder': 'Resultados da sua busca / Código Online do configurador',

    'suggestions.all_search_results': 'Todos os resultados da pesquisa',
    'suggestions.all_search_results_for': 'Mostrar todos os resultados para',
    'suggestions.in': 'em',

    all: 'Todos',
    UCOS: 'Loja online de carros usados',
    PASSENGER_CARS: 'Automóveis',
    VANS: 'Vans',
    NCOS: 'Loja online de carros novos',
    VIDEO: 'Vídeos',
    DEALER_LOCATOR: 'Pesquisa de concessionárias',
    CONFIGURATOR: 'Configurador',
    TEST_DRIVE: 'Test Drive',
    VEHICLE_SEARCH: 'Pesquisa de veículos',
    COLLECT: 'Acessórios e colecionáveis',
    CONNECT: 'Loja Mercedes me',

    'search.result.consumption': 'Consumo',
    'watch.video': 'Ver o vídeo',
    'input.recently': 'Pesquisas recentes',
    'input.help.title': 'O que deve procurar?',
    'input.help.text':
      'Pesquise através dos tipos de veículos, modelos, códigos de configuração ou por acessórios, outros produtos e informações',

    'search.result.grid': 'Grade',
    'search.result.list': 'Lista',

    // No results found
    'support.check': 'Verifique se há erros de escrita ou tente novamente com um termo diferente.',
    'support.no.results': 'Não há resultados de pesquisa disponíveis para este termo de pesquisa.',
    'support.no.results.term': 'Nenhum resultado encontrado',
    'support.chat': 'Não consegue encontrar o que procura? Por favor, use o nosso',
    'support.chat.with.us': 'Suporte Online-Chat',
  },
  es_AR: {
    'consumption.co2': `Emisiones de ${co2} ciclo mixto`,
    'consumption.energy': 'Consumo de corriente mixto',
    'consumption.fuel': 'Consumo de combustible mixto',
    'footnotes.local': '',
    'footnotes.wltp': '',
    'footnotes.nedc':
      'Los valores indicados se han determinado según el procedimiento de medición prescrito en el Reglamento [CE] 715/2007 en su versión vigente en la actualidad (Directiva 1999/94/CEE en su versión actual)',
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Tu búsqueda / Código online del configurador',
    'search.result.buy-online': 'Compra online',
    'search.results':
      'No se han encontrado resultados | Se ha encontrado 1 resultado | Se han encontrado {count} resultados',
    'search.results.backup': 'No se han encontrado coincidencias. Ver páginas relacionadas:',
    'search.results.count': 'Se han encontrado {count} resultados',
    'search.results.none.summary':
      'No hay resultados disponibles para este término de búsqueda. Intentalo de nuevo con otro término de búsqueda.',
    'search.show-more': 'Mostrar más',
    'search.unavailable': 'La búsqueda no se encuentra disponible en este momento.',
    'search.result.new': 'Nuevo',

    'search.result.consumption': 'Consumo',

    'input.placeholder': 'Tu búsqueda / Código online del configurador',

    'suggestions.all_search_results': 'Todos los resultados de la búsqueda',
    'suggestions.all_search_results_for': 'Mostrar todos los resultados para',
    'suggestions.in': 'en',

    all: 'Todos',
    UCOS: 'Tienda online de vehículos usados',
    PASSENGER_CARS: 'Vehículos',
    VANS: 'Vans',
    NCOS: 'Tienda online de vehículos nuevos',
    VIDEO: 'Videos',
    DEALER_LOCATOR: 'Localizador de concesionarios',
    CONFIGURATOR: 'Configurador de vehículos Mercedes-Benz',
    TEST_DRIVE: 'Prueba de manejo',
    VEHICLE_SEARCH: 'Buscador de vehículos usados',
    COLLECT: 'Colección y accesorios',
    CONNECT: 'Mercedes me Store',

    'watch.video': 'Vea el vídeo',
    'input.recently': 'Buscado recientemente',
    'input.help.title': '¿Qué puedes buscar?',
    'input.help.text':
      'Puedes realizar búsquedas indicando el tipo de vehículo, el modelo, códigos de configuración o bien buscar accesorios, otros productos e información',

    'search.result.grid': 'Cuadrícula',
    'search.result.list': 'Lista',

    // No results found
    'support.check':
      'Comprueba que no has cometido errores de ortografía, o inténtalo de nuevo con un término diferente.',
    'support.no.results': 'No hay resultados disponibles para este término de búsqueda.',
    'support.no.results.term': 'No se ha encontrado ningún resultado',
    'support.chat': '¿No has encontrado lo que estabas buscando? Acude a nuestro servicio de asistencia por',
    'support.chat.with.us': 'conversación online',
  },
  lt_LT: {
    'consumption.co2': `${co2} emisija, mišri`,
    'consumption.energy': 'Energijos sąnaudos, mišrios',
    'consumption.fuel': 'Degalų sąnaudos, mišrios',
    'footnotes.local': '',
    'footnotes.wltp': '',
    'footnotes.nedc':
      'Pateikti skaičiai buvo gauti laikantis nustatyto matavimo proceso. Jie yra NEDC CO2 vertės (ES) 2017/1153 reglamentą. Degalų sąnaudos buvo apskaičiuotos remiantis šiomis vertėmis. Elektros energijos sąnaudos buvo nustatytos remiantis direktyva 692/2008/EB.',
    'footnotes.emissions.appendix':
      'Norėdami gauti daugiau informacijos apie oficialias naujų lengvųjų automobilių degalų sąnaudas ir išmetamą CO2 kiekį, kreipkitės į įgaliotąjį Mercedes-Benz atstovą.',
    'search.input.label': 'Jūsų paieškos terminas / OnlineCode Configurator',
    'search.result.buy-online': 'Pirkite internetu',
    'search.results': 'Rezultatų nerasta | {count} paieškos rezultatas | {count} paieškos rezultatų',
    'search.results.backup': 'Tikslių atitikčių nerasta. Peržiūrėkite susijusius puslapius:',
    'search.results.count': '{count} paieškos rezultatų',
    'search.results.none.summary': 'Nėra šios paieškos rezultatų. Bandykite dar kartą naudodami kitą paieškos žodį.',
    'search.show-more': 'Rodyti daugiau',
    'search.unavailable': 'Paieška šiuo metu nepasiekiama.',
    'search.result.new': 'Nauja',

    'input.placeholder': 'Jūsų paieškos terminas / OnlineCode Configurator',

    'suggestions.all_search_results': 'Visi paieškos rezultatai',
    'suggestions.all_search_results_for': 'Parodyti visus rezultatus',
    'suggestions.in': 'esantys',

    all: 'All',
    UCOS: 'Used vehicle Online Store',
    PASSENGER_CARS: 'Passenger cars',
    VANS: 'Vans',
    NCOS: 'New vehicle Online Store',
    VIDEO: 'Videos',
    DEALER_LOCATOR: 'Dealer search',
    CONFIGURATOR: 'Mercedes-Benz Car Configurator',
    TEST_DRIVE: 'Test drive',
    VEHICLE_SEARCH: 'Used Cars',
    COLLECT: 'Collection & ACCESSORIES',
    CONNECT: 'Mercedes me Store',

    'search.result.consumption': 'Sąnaudos',
    'watch.video': 'Žiūrėti vaizdo įrašą',
    'input.recently': 'Neseniai ieškota',
    'input.help.title': 'Ko turėtumėte ieškoti?',
    'input.help.text':
      'Paieška pagal transporto priemonės rūšis, modelius, konfigūracijos kodus arba priedams, kitiems produktams ir informacijai',

    'search.result.grid': 'Tinklelis',
    'search.result.list': 'Sąrašas',

    // Empty result
    'support.check': 'Patikrinkite, ar nėra rašybos klaidų, arba pabandykite naudoti kitą terminą.',
    'support.no.results': 'Paieškos rezultatų pagal šį paieškos terminą nėra.',
    'support.no.results.term': 'Rezultatų nerasta.',
    'support.chat': 'Nerandate to, ko ieškote? Naudokite mūsų terminus.',
    'support.chat.with.us': 'Pagalba per internetinį pokalbį.',
  },
  uk_UA: {
    'consumption.co2': 'Рівень викидів CO2 у комбінованому циклі',
    'consumption.energy': 'Споживання електроенергії у комбінованому циклі випробувань',
    'consumption.fuel': 'Витрата палива у комбінованому циклі',
    'footnotes.local': '',
    'footnotes.wltp':
      'Вказані значення було розраховано згідно з рекомендованою процедурою вимірювання. Ідеться про «значення WLTP-CO2» згідно зі статтею 2 п. 3 Імплементаційного регламенту (ЄС) 2017/1153. Значення витрати палива розраховані на основі цих показників. Показники витрати палива розраховано згідно з Постановою 683/2008/ЄС. Дані не стосуються окремого автомобіля, не є частиною пропозиції, а наведені виключно в цілях порівняння описаних моделей. Значення варіюються залежно від обраного опціонального обладнання й можуть відрізнятися від остаточних значень замовленого або доставленого автомобіля.',
    'footnotes.nedc':
      'Вказані значення було розраховано згідно з рекомендованою процедурою вимірювання. Ідеться про «значення NEFZ-CO2» згідно зі статтею 2 п. 1 Імплементаційного регламенту (ЄС) 2017/1153. Значення витрати палива розраховані на основі цих показників. Показники витрати палива розраховано згідно з Постановою 692/2008/ЄС. Відомості не стосуються окремого автомобіля й не є частиною пропозиції, а слугують винятково для проведення порівняння між різними типами автомобілів. Значення варіюються залежно від обраного опціонального обладнання.',
    'footnotes.emissions.appendix': '',
    'search.input.label': 'Ваш пошуковий запит / Конфігуратор OnlineCode',
    'search.result.buy-online': 'Купити онлайн',
    'search.results': 'Результатів пошуку не знайдено | {count} Результат пошуку | {count} Більше результатів пошуку',
    'search.results.count': '{count} Більше результатів пошуку',
    'search.results.backup': 'Точних співпадінь, не знайдено. Переглянути схожі сторінки:',
    'search.results.none.summary':
      'З цього запиту немає результатів пошуку. Будь ласка, спробуйте ще раз з іншим пошуковим запитом.',
    'search.show-more': 'Показати більше',
    'search.unavailable': 'Наразі пошук недоступний.',
    'search.result.new': 'Новий',

    'input.placeholder': 'Ваш пошуковий запит / Конфігуратор OnlineCode',

    'suggestions.all_search_results': 'Усі результати пошуку',
    'suggestions.all_search_results_for': 'Показати всі результати для',
    'suggestions.in': 'у',

    all: 'Усі',
    UCOS: 'Used vehicle Online Store',
    PASSENGER_CARS: 'Легкові автомобілі',
    VANS: 'Мікроавтобуси',
    NCOS: 'New vehicle Online Store',
    VIDEO: 'Відео',
    DEALER_LOCATOR: 'Пошук дилера',
    CONFIGURATOR: 'Mercedes-Benz Car Configurator',
    TEST_DRIVE: 'Тест драйв',
    VEHICLE_SEARCH: 'Пошук вживаних автомобілів',
    COLLECT: 'Collection & ACCESSORIES',
    CONNECT: 'Mercedes me Store',

    'search.result.consumption': 'Споживання',
    'watch.video': 'Переглянути відео',
    'input.recently': 'Нещодавній пошук',
    'input.help.title': 'Що вам потрібно знайти?',
    'input.help.text':
      'Шукайте за типами транспортних засобів, моделями, кодами конфігурації або аксесуарами, інші вироби та інформацію',

    'search.result.grid': 'Grid',
    'search.result.list': 'List',

    // Empty result
    'support.check': 'Перевірте наявність помилок або повторіть спробу з іншим терміном.',
    'support.no.results': 'За цим пошуковим запитом не знайдено жодного результату.',
    'support.no.results.term': 'Не знайдено жодного результату.',
    'support.chat': 'Не можете знайти те, що шукаєте? Скористайтеся нашим. ',
    'support.chat.with.us': 'Підтримка в онлайн чаті.',
  },
  cs_CZ: {
    'consumption.co2': 'Kombinované emise CO2',
    'consumption.energy': 'Kombinovaná spotřeba energie',
    'consumption.fuel': 'Kombinovaná spotřeba paliva',
    'footnotes.local': '',
    'footnotes.wltp':
      'Uvedené hodnoty byly stanoveny podle předepsané metody měření. Jedná se o „hodnoty CO2 WLTP“ ve smyslu čl. 2 č. 3 prováděcího nařízení (EU) 2017/1153. Na základě těchto hodnot byly vypočítány hodnoty spotřeby paliva. Spotřeba elektrické energie byla stanovena na základě VO 683/2008 / EG. Informace se netýkají jediného vozidla a nejsou součástí nabídky, ale slouží pouze pro účely srovnání mezi různými typy vozidel. Hodnoty se liší v závislosti na zvoleném volitelném vybavení.',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix':
      'Další informace o spotřebě paliva a emisích CO2 u nových osobních automobilů Vám poskytne autorizovaný prodejce Mercedes-Benz.',
    'search.input.label': 'Váš hledaný výraz / OnlineCode konfigurátoru',
    'search.result.buy-online': 'Koupit online',
    'search.results': 'Nebyly nalezeny žádné výsledky | {count} výsledek hledání | Počet výsledků vyhledávání: {count}',
    'search.results.count': 'Počet výsledků vyhledávání: {count}',
    'search.results.backup': 'Nebyly nalezeny žádné přesné shody. Zobrazit související stránky:',
    'search.results.none.summary':
      'Pro tento hledaný výraz nejsou k dispozici žádné výsledky vyhledávání. Zkuste to prosím znovu s jiným výrazem.',
    'search.show-more': 'Zobrazit více',
    'search.unavailable': 'Vyhledávání není aktuálně k dispozici.',
    'search.result.new': 'Nové',

    'input.placeholder': 'Váš hledaný výraz / OnlineCode konfigurátoru',

    'suggestions.all_search_results': 'Svi rezultati pretraživanja',
    'suggestions.all_search_results_for': 'Prikaži sve rezultate za',
    'suggestions.in': 'u',

    all: 'Všechny',
    UCOS: 'Ojeté vozidlo | Internetový obchod',
    PASSENGER_CARS: 'Osobní vozidlo',
    VANS: 'Dodávková vozidla',
    NCOS: 'Nové vozidlo | Internetový obchod',
    VIDEO: 'Videa',
    DEALER_LOCATOR: 'Vyhledávání prodejců',
    CONFIGURATOR: 'Konfigurátor vozů Mercedes-Benz',
    TEST_DRIVE: 'Zkušební jízda',
    VEHICLE_SEARCH: 'Vyhledávání ojetých vozidel',
    COLLECT: 'Kolekce a příslušenství',
    CONNECT: 'Mercedes me Store',

    'search.result.consumption': 'Potrošnja',
    'watch.video': 'Pogledaj videozapis',
    'input.recently': 'Nedavno pretražno',
    'input.help.title': 'Co byste měli hledat?',
    'input.help.text':
      'Vyhledávání pomocí typů vozidel, modelů, konfiguračních kódů nebo PŘÍSLUŠENSTVÍ, dalších produktů a informací',

    'search.result.grid': 'Mřížka',
    'search.result.list': 'Seznam',

    //No results found
    'support.check': 'Zkontrolujte, zda nedošlo k překlepu, nebo to zkuste znovu s jiným výrazem.',
    'support.no.results': 'Pro tento výraz nejsou k dispozici žádné výsledky vyhledávání.',
    'support.no.results.term': 'Nebyly nalezeny žádné výsledky',
    'support.chat': 'Nemůžete najít, co hledáte? Využijte naši online',
    'support.chat.with.us': 'podporu prostřednictvím chatu.',
  },
  en_EG: {
    ...englishMessages,
  },
  ar_EG: {
    'consumption.co2': `${co2} انبعاثات مجتمعة`,
    'consumption.energy': 'استهلاك الطاقة في دورة الاختبار المركبة',
    'consumption.fuel': 'استهلاك الوقود مجتمعة',
    'footnotes.local': '',
    'footnotes.wltp': '',
    'footnotes.nedc':
      'تم الحصول على الأرقام الموضحة وفقًا لعملية القياس المحددة. إنها "قيم NEDC CO2" وفقًا للفن. 2 رقم 1 من اللائحة التنفيذية (الاتحاد الأوروبي) 2017/1153. تم حساب أرقام استهلاك الوقود على أساس هذه القيم. تم تحديد الاستهلاك الكهربائي على أساس التوجيه 692/2008 / EC.',
    'footnotes.emissions.appendix':
      'لمزيد من المعلومات حول الاستهلاك الرسمي للوقود وانبعاثات ثاني أكسيد الكربون لسيارات الركاب الجديدة ، يرجى الاتصال بوكيل مرسيدس-بنز المعتمد.',
    'search.input.label': '',
    'search.result.buy-online': 'شراء عبر الإنترنت',
    'search.results': 'لم يتم العثور على نتائج | {count} نتيجة البحث | {count} نتائج البحث',
    'search.results.count': '{count} نتائج البحث',
    'search.results.backup': 'لم يتم العثور على تطابقات تامة. عرض الصفحات ذات الصلة:',
    'search.results.none.summary': 'لا توجد نتائج بحث متاحة لمصطلح البحث هذا. يرجى المحاولة مرة أخرى بمصطلح مختلف.',
    'search.show-more': 'أظهر المزيد',
    'search.unavailable': 'البحث غير متوفر حاليا.',
    'search.result.new': 'الجديد',

    'search.result.consumption': 'الاستهلاك',

    'watch.video': 'شاهد الفيديو',
    'input.recently': 'آخر بحث',
    'input.help.title': 'ما الذي تبحث عنه؟',
    'input.help.text': 'ابحث باستخدام أنواع السيارات وطرازاتها وأكواد التهيئة أو عن ملحقات ومنتجات ومعلومات أخرى',

    'search.result.grid': 'Mřížka',
    'search.result.list': 'Seznam',
  },
  lv_LV: {
    'consumption.co2': `${co2} emisija kombinēti`,
    'consumption.energy': 'Strāvas patēriņš kombinētajā ciklā',
    'consumption.fuel': 'Kombinētais degvielas patēriņš',
    'footnotes.local': '',
    'footnotes.wltp':
      'Norādītās vērtības tika iegūtas saskaņā ar noteikto mērīšanas procedūru. Runa ir par “NEDC CO2 vērtībām” Komisijas Īstenošanas regulas (ES) 2017/1153 2. panta 3. punkta izpratnē. Strāvas patēriņš tika iegūts, pamatojoties uz Eiropas Parlamenta un Padomes Regulu (EK) Nr. 683/2008. Šie dati neattiecas uz konkrētu automobili un nav piedāvājuma sastāvdaļa, bet gan paredzēti tikai salīdzināšanai ar dažādiem automobiļu tipiem. Vērtības mainās atkarībā no izvēlētā speciālaprīkojuma.',
    'footnotes.nedc':
      'Norādītās vērtības tika iegūtas saskaņā ar noteikto mērīšanas procedūru. Runa ir par “NEDC CO2 vērtībām” Komisijas Īstenošanas regulas (ES) 2017/1153 2. panta 1. punkta izpratnē. Degvielas patēriņa vērtības tika aprēķinātas, pamatojoties uz šīm vērtībām. Šie dati neattiecas uz konkrētu automobili un nav piedāvājuma sastāvdaļa, bet gan paredzēti tikai salīdzināšanai ar dažādiem automobiļu tipiem. Vērtības mainās atkarībā no izvēlētā speciālaprīkojuma.',
    'footnotes.emissions.appendix':
      'Lai iegūtu vairāk informācijas par jaunu vieglo automobiļu oficiālo degvielas patēriņu un CO2 emisiju, lūdzu, sazinieties ar savu pilnvaroto Mercedes-Benz dīleri.',
    'search.input.label': 'Jūsu meklējums / OnlineCode konfigurators',
    'search.result.buy-online': 'Pirkt tiešsaistē',
    'search.results.count': '{count} meklēšanas rezultāti',
    'search.results':
      'Neatrada nevienu meklēšanas rezultātu | {count} meklēšanas rezultāts | {count} meklēšanas rezultāti',
    'search.results.backup': 'Neatrada nevienu precīzu atbilstību. Apskatiet radniecīgas lapas:',
    'search.results.none.summary':
      'Šim jēdzienam nav meklēšanas rezultātu. Lūdzu, pamēģiniet no jauna kādu citu meklējumu.',
    'search.show-more': 'Parādīt vairāk',
    'search.unavailable': 'Meklētājs pašlaik nav pieejams.',
    'search.result.new': 'Jauns',

    'input.placeholder': 'Jūsu meklējums / OnlineCode konfigurators',

    'suggestions.all_search_results': 'Visi meklēšanas rezultāti',
    'suggestions.all_search_results_for': 'Rādīt visus rezultātus',
    'suggestions.in': 'vietnē',

    all: 'Všechny',
    UCOS: 'Ojeté vozidlo | Internetový obchod',
    PASSENGER_CARS: 'Osobní vozidlo',
    VANS: 'Dodávková vozidla',
    NCOS: 'Nové vozidlo | Internetový obchod',
    VIDEO: 'Videa',
    DEALER_LOCATOR: 'Vyhledávání prodejců',
    CONFIGURATOR: 'Konfigurátor vozů Mercedes-Benz',
    TEST_DRIVE: 'Zkušební jízda',
    VEHICLE_SEARCH: 'Vyhledávání ojetých vozidel',
    COLLECT: 'Kolekce a příslušenství',
    CONNECT: 'Mercedes me Store',

    'search.result.consumption': 'Patēriņš',
    'watch.video': 'Skatīties video',
    'input.recently': 'Nesen meklēts',
    'input.help.title': 'Kas būtu jāmeklē?',
    'input.help.text':
      'Meklēt, izmantojot automobiļu tipus, modeļus, konfigurācijas kodus vai piederumus, citus produktus un informāciju',

    'search.result.grid': 'Galerija',
    'search.result.list': 'Saraksts',
  },
  sl_SI: {
    'consumption.co2': `Kombinirane emisije ${co2}`,
    'consumption.energy': 'Poraba energije v kombinirani testni vožnji',
    'consumption.fuel': 'Kombinirana poraba goriva',
    'footnotes.local': '',
    'footnotes.wltp':
      'Navedene vrednosti so bile pridobljene v skladu s predpisanim postopkom merjenja. To so »vrednosti CO2 po protokolu WLTP« v povezavi s 3. točko 2. člena Izvedbene Uredbe (EU) 2017/1153. Vrednosti porabe goriva so bile izračunane na podlagi teh vrednosti. Poraba električne energije je bila določena na podlagi Uredbe (EU) 2017/1151 in Uredbe (ES) 692/2008. Podatki se ne nanašajo na posamezno vozilo in niso sestavni del ponudbe, ampak služijo le za primerjavo med različnimi tipi vozil. Vrednosti se razlikujejo glede na izbrano dodatno opremo.',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix':
      'Za več informacij o uradni porabi goriva in emisijah CO2 novih osebnih vozil se obrnite na svojega pooblaščenega prodajalca vozil Mercedes-Benz.',
    'search.input.label': 'Vaš iskalni pojem/konfigurator OnlineCode',
    'search.result.buy-online': 'Kupite prek spleta',
    'search.results.count': 'število zadetkov iskanja: {count}',
    'search.results': 'Brez zadetkov | število zadetkov iskanja: {count} | število zadetkov iskanja: {count}',
    'search.results.backup': 'Ni natančnega ujemanja. Oglejte si sorodne strani:',
    'search.results.none.summary':
      'Za ta iskalni pojem ni na voljo zadetkov iskanja. Poskusite ponovno z drugim pojmom.',
    'search.show-more': 'Več',
    'search.unavailable': 'Iskanje trenutno ni na voljo.',
    'search.result.new': 'Novo',
    'input.placeholder': 'Vaš iskalni pojem/konfigurator OnlineCode',

    'suggestions.all_search_results': 'Vsi rezultati iskanja',
    'suggestions.all_search_results_for': 'Prikaži vse rezultate za',
    'suggestions.in': 'v',

    all: 'Vse',
    UCOS: 'Spletna trgovina z rabljenimi vozili',
    PASSENGER_CARS: 'Osebna vozila',
    VANS: 'Dostavna vozila',
    NCOS: 'Spletna trgovina z novimi vozili',
    VIDEO: 'Videoposnetki',
    DEALER_LOCATOR: 'Iskanje trgovca',
    CONFIGURATOR: 'Konfigurator Mercedes-Benz',
    TEST_DRIVE: 'Poskusna vožnja',
    VEHICLE_SEARCH: 'Iskalnik rabljenih vozil',
    COLLECT: 'Kolekcija in dodatna oprema',
    CONNECT: 'Trgovina Mercedes me Store',

    'search.result.consumption': 'Potrošnja',
    'watch.video': 'Oglejte si videoposnetek',
    'input.recently': 'Nedavno iskano',
    'input.help.title': 'Kaj morate iskati?',
    'input.help.text':
      'Iskanje po tipih vozila, modelih, konfiguracijskih kodah ali po dodatni opremi, drugih izdelkih in informacijah',

    'search.result.grid': 'Mreža',
    'search.result.list': 'Številka',

    // Empty result
    'support.check': 'Prosimo, preverite črkovanje ali poskusite znova z drugim izrazom.',
    'support.no.results': 'Za ta iskalni izraz ni zadetkov.',
    'support.no.results.term': 'Ni zadetkov',
    'support.chat': 'Ne najdete, kar iščete? Prosimo, uporabite naše. ',
    'support.chat.with.us': 'Podpora prek spletnega klepeta.',
  },
  en_CY: {
    // CSY
    ...englishMessages,
  },
  is_IS: {
    'consumption.co2': `${co2} losun í blönduðum akstri`,
    'consumption.energy': 'Orkunotkun í prófunarferli í blönduðum akstri',
    'consumption.fuel': 'Eldsneytisnotkun í blönduðum akstri',
    'footnotes.local': '',
    'footnotes.wltp': '',
    'footnotes.nedc':
      'Tölurnar byggja á niðurstöðum úr stöðluðu mælingaferli. Þær innihalda „NEDC CO2 values" skv. 2. gr. 1. reglugerðar (ESB) 2017/1153. Tölur um eldsneytisnotkun hafa verið reiknaðar út frá þessum gildum. Rafmagnsnotkun hefur verið ákvörðuð á grundvelli tilskipunar 692/2008/ EB.',
    'footnotes.emissions.appendix':
      'Nánari upplýsingar um eldsneytisnotkun og CO2 losun nýrra fólksbíla fást hjá viðurkenndum Mercedes-Benz söluaðila.',
    'search.input.label': 'Leitarorð þitt / OnlineCode stillingar',
    'search.result.buy-online': 'Kaupa á netinu',
    'search.results.count': '{count} leitarniðurstaða',
    'search.results': 'Engin leitarniðurstaða | {count} leitarniðurstaða | {count} leitarniðurstaða',
    'search.results.backup': 'Engin nákvæm samsvörun fannst. Skoða tengdar síður:',
    'search.results.none.summary':
      'Engar leitarniðurstöður eru tiltækar fyrir þetta leitarorð. Reyndu aftur með öðru leitarorði.',
    'search.show-more': 'Sýna fleiri niðurstöður',
    'search.unavailable': 'Leit er ekki í boði eins og er.',
    'search.result.new': 'Nýr',

    'input.placeholder': 'Leitarorð þitt / OnlineCode stillingar',

    'suggestions.all_search_results': 'Allar leitarniðurstöður',
    'suggestions.all_search_results_for': 'Sýna allar niðurstöður fyrir',
    'suggestions.in': 'í',

    all: 'Allt',
    UCOS: 'Used vehicle Online Store',
    PASSENGER_CARS: 'Fólksbílar',
    VANS: 'Atvinnubílar',
    NCOS: 'New vehicle Online Store',
    VIDEO: 'Myndbönd',
    DEALER_LOCATOR: 'Sölu- og þjónustuaðilar',
    CONFIGURATOR: 'Mercedes-Benz Car Configurator',
    TEST_DRIVE: 'Reynsluakstur',
    VEHICLE_SEARCH: 'Leit á notuðum bílum',
    COLLECT: 'Gjafavara og aukahlutir',
    CONNECT: 'Mercedes me ',

    'search.result.consumption': 'Neysla',
    'watch.video': 'Horfðu á myndbandið',
    'input.recently': 'Nýlega leitað',
    'input.help.title': 'Hverju er hægt aj leita að?',
    'input.help.text':
      'Hægt er að leita frá bílategund, bíltegund og skráningarnúmeri eða leita að aukahlutum, öðrum vörum og upplýsingum',

    'search.result.grid': 'Grid',
    'search.result.list': 'List',

    // Empty result
    'support.check': 'Athugaðu með innsláttarvillur eða reyndu aftur með öðru leitarorði.',
    'support.no.results': 'Engar leitarniðurstöður eru í boði fyrir þetta leitarorð.',
    'support.no.results.term': 'Leitin skilaði engum niðurstöðum.',
    'support.chat': 'Finnurðu ekki það sem þú ert að leita að? Notaðu þá okkar leit. ',
    'support.chat.with.us': 'Netspjall.',
  },
  hr_BA: {
    'input.placeholder': 'Vaš termin za pretragu / Konfigurator OnlineCode',
    ...croatianMessages,
  },
  hr_RS: {
    'input.placeholder': 'Vaš termin za pretragu / Konfigurator OnlineCode',
    ...croatianMessages,
  },
  en_VN: {
    ...englishMessages,
  },
  vi_VN: {
    'consumption.co2': `Mức phát thải ${co2}, kết hợp`,
    'consumption.energy': 'Mức tiêu thụ năng lượng theo chu kỳ kết hợp',
    'consumption.fuel': 'Mức tiêu thụ nhiên liệu, kết hợp',
    'footnotes.local':
      'Các thông số kỹ thuật nêu trên chỉ mang tính tham khảo và có thể thay đổi mà không cần phải thông báo trước. Ngoài ra, các thông tin chứa đựng trong Thông tin Sản phẩm này sẽ không được dùng như là tài liệu hợp đồng đối với một xe cụ thể được bán cho khách hàng trong tương lai.',
    'footnotes.wltp': '',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix':
      'Để biết thêm chi tiết về mức phát thải CO2 và mức tiêu thụ nhiên liệu của xe mới, vui lòng liên hệ các nhà phân phối chính hãng của Mercedes-Benz.',
    'search.input.label': 'Từ khóa tìm kiếm / OnlineCode từ công cụ chọn cấu hình xe',
    'search.result.buy-online': 'Mua online',
    'search.results.count': 'Tìm thấy {count} kết quả',
    'search.results': 'Không tìm thấy kết quả | Tìm thấy {count} kết quả | Tìm thấy {count} kết quả',
    'search.results.backup': 'Không tìm thấy kết quả đúng như từ khóa của bạn. Xem các trang có liên quan:',
    'search.results.none.summary': 'Không có kết quả nào phù hợp cho từ khóa của bạn. Vui lòng nhập từ khóa khác.',
    'search.show-more': 'Hiển thị thêm',
    'search.unavailable': 'Tính năng tìm kiếm hiện không có sẵn.',
    'search.result.new': 'New',
    'input.placeholder': 'Từ khóa tìm kiếm / OnlineCode từ công cụ chọn cấu hình xe',

    'search.result.consumption': 'Mức tiêu thụ',
    'watch.video': 'Xem video',
    'input.recently': 'Được tìm kiếm gần đây',
    'input.help.title': 'Bạn cần tìm cái gì?',
    'input.help.text': 'Tìm kiếm theo loại xe, mẫu xe, mã cấu hình hoặc các phụ kiện, sản phẩm và thông tin khác',

    'search.result.grid': 'Lưới',
    'search.result.list': 'Danh sách',

    //No results
    'support.check': 'Vui lòng kiểm tra lỗi chính tả hoặc thử lại với một thuật ngữ khác.',
    'support.no.results': 'Không có kết quả tìm kiếm nào cho cụm từ tìm kiếm này.',
    'support.no.results.term': 'Không tìm thấy kết quả nào',
    'support.chat': 'Không thể tìm thấy những gì bạn đang tìm kiếm? Vui lòng sử dụng Hỗ trợ trò chuyện ',
    'support.chat.with.us': 'trực tuyến của chúng tôi',
  },
  zh_TW: {
    'consumption.co2': 'CO2 綜合排放值',
    'consumption.energy': '能耗',
    'consumption.fuel': '油耗',
    'footnotes.local':
      '本網站所標示之油耗測試係在實驗室內，依規定的行車型態於車體動力計上測得，實際道路行駛時，因天候、路況、載重、使用空調系統、駕駛習慣及車輛維修保養等因素影響，其於道路上每公升行駛的公里數應低於所標示之油耗測試值。其他標示之各項測試數據 ( 例如二氧化碳排放量或加速時間 ) 係在控制變因下所測得，實際駕駛時因受各項變因影響而會有所不同。',
    'footnotes.wltp':
      '本網站標示之WLTP測試範圍下所得之數據 (如加速度時間及純電行駛里程等) 係在實驗室內，依規定的行車型態測得。實際駕駛因受天候、路況、載重、駕駛習慣及維護保養等影響而會有所不同，僅供參考。本標示所示為原廠於歐盟測試數據，僅供參考。',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix': '',
    'search.input.label': '請輸入關鍵字或訂製夢想車代碼',
    'search.result.buy-online': '',
    'search.results': '無相關搜尋結果| {count}項搜尋結果| {count}項搜尋結果',
    'search.results.count': '{count}項搜尋結果',
    'search.results.backup': '找不到完全符合此搜尋項目之結果，請查看相關頁面：',
    'search.results.none.summary': '找不到符合此搜尋項目之結果，請使用其他關鍵字搜尋。',
    'search.show-more': '顯示更多',
    'search.unavailable': '目前無法使用搜尋功能，請稍後再試。',
    'search.result.new': '新奇',

    'search.result.consumption': '消耗',

    'input.placeholder': '請輸入關鍵字或訂製夢想車代碼',

    'suggestions.all_search_results': '所有搜尋結果',
    'suggestions.all_search_results_for': '顯示所有結果',
    'suggestions.in': '在',

    all: '全部',
    UCOS: '二手車線上商店',
    PASSENGER_CARS: '轎車',
    VANS: '商旅車',
    NCOS: '',
    VIDEO: '影片',
    DEALER_LOCATOR: '經銷商搜尋',
    CONFIGURATOR: '訂製夢想車',
    TEST_DRIVE: '預約賞車',
    VEHICLE_SEARCH: '搜尋車款',
    COLLECT: 'Mercedes-Benz Collection 賓士精品',
    CONNECT: 'Mercedes Me Store 線上商店',

    'watch.video': '最近搜尋',
    'input.recently': '最近搜尋',
    'input.help.title': '您可尋找什麼資訊？',
    'input.help.text': '使用車款或車型名稱、訂製夢想車代碼、配備或其他產品資訊進行搜尋',

    'search.result.grid': '網格',
    'search.result.list': '列表',

    // Empty result
    'support.check': '請檢查是否存在拼寫錯誤，或使用其他字詞再試一次。',
    'support.no.results': '此搜尋字詞查無搜尋結果。',
    'support.no.results.term': '查無結果。',
    'support.chat': '找不到您想找的內容？請使用我們的。',
    'support.chat.with.us': '網上對話支援。',
  },
  en_MT: {
    ...englishMessages,
    'footnotes.local':
      'The indicated values were determined according to the prescribed measurement method - Worldwide Harmonised Light Vehicle Test Procedure (WLTP). Figures shown may include options which are not available in Malta. WLTP CO2 values will be effective from 1st April 2020. Additionally [a] For Battery Electric Vehicles (BEV) figures determined with battery fully charged. These models require mains electricity for charging. [b] For Plug-in Hybrid Electric Vehicle (PHEV) figures determined with the battery fully charged, using a combination of both battery power and fuel. Figures shown are for comparability purposes only. Figures may differ from real life driving results, which will depend upon a number of factors including (a) the starting charge of the battery (b), factory fitted options,(c) ACCESSORIES fitted (post registration), variations in weather, driving styles and vehicle load. Further information about the test used to establish fuel consumption and CO₂ figures can be found at www.mercedes-benz.com.mt.',
  },
  ko_KR: {
    'consumption.co2': `${co2} 배출량`,
    'consumption.energy': '전력소모량',
    'consumption.fuel': '연료소모량',
    'footnotes.local':
      '주행거리는 표준 모드에 의한 연비로써 도로 상태, 운전 방법, 차량 적재, 정비 상태 및 외기 온도에 따라 실주행거리와 차이가 있습니다. 사양 및 옵션은 세부 모델에 따라 다르게 적용됩니다. 본 웹사이트에 기재된 내용은 사전에 예고 없이 변경될 수 있습니다.',
    'footnotes.wltp': '',
    'footnotes.nedc': '',
    'footnotes.emissions.appendix':
      '차량의 공식 연료소묘량 및 CO2 배출량에 대한 자세한 내용은 공인 Mercedes-Benz 전시장에 문의하시기 바랍니다.',
    'search.input.label': '검색어 / 모델 코드',
    'search.result.buy-online': '지금 주문하기',
    'search.results': `검색 결과가 없습니다. | {count} 개의 검색 결과`,
    'search.results.count': '{count} 개의 검색 결과',
    'search.results.backup': '검색과 일치하는 항목이 없습니다. 관련된 내용:',
    'search.results.none.summary': '검색 결과가 없습니다. 검색 옵션을 변경해서 다시 검색해 보세요.',
    'search.show-more': '검색 결과 더보기',
    'search.unavailable': '검색 기능을 현재 사용할 수 없습니다',
    'search.result.new': '',

    didyoumean: '이것을 찾으시나요',
    all: '모두',
    configurator: 'Configurator',
    collect: 'Collection & ACCESSORIES',
    connect: 'Mercedes me store',
    ncos: 'New Cars Online Store',
    ucos: 'Used Cars Online Store',
    dealer_locator: 'Dealer Locator',
    passenger_cars: 'Passenger Cars',
    test_drive: 'Test Drive',
    vans: 'Vans',
    vehicles_search: 'Vehicle Search',
    video: 'Video',
    related_search: '관련 검색',
    'input.placeholder': '검색어 / 모델 코드',

    'search.result.consumption': '	최근 검색함',
    'watch.video': '	동영상 보기',
    'input.recently': '	최근 검색함',
    'input.help.title': '무엇을 찾으십니까?',
    'input.help.text': '차량 유형, 모델, 구성 코드를 사용한 검색 또는 액세서리, 다른 제품 및 정보 검색',

    'search.result.grid': '網格',
    'search.result.list': '列表',

    //No results page
    'support.check': '오탈자는 없는지 확인하시고 다른 용어로 다시 시도해보십시오.',
    'support.no.results': '이 검색어에 해당하는 검색 결과가 없습니다.',
    'support.no.results.term': '검색 결과가 없습니다.',
    'support.chat': '검색하는 내용이 없습니까? 온라인 채팅 지원 기능을 이용해보십시오.',
  },
};
